import { Component, Inject, Injector, OnInit, Optional, TemplateRef, ViewChild } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DIALOG_DATA, MatDialog, MatDialogRef, Sort } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { MatHorizontalStepper, MatStepper } from '@angular/material/stepper';
import { cloneDeep, sortBy } from 'lodash';
import * as _ from 'lodash';

// ProperUI Display
import { MatSnackBar } from '@angular/material';
import { Http, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { LoadingModalComponent } from 'app/modals/loading-modal/loading-modal.component';
import { ImgPreviewerComponent } from 'app/modals/img-previewer/img-previewer.component';
import { PageTitleService } from 'app/core/page-title/page-title.service';
import { Router } from '@angular/router';
import { SharedDataService } from 'app/shared-data.service';
import * as moment from 'moment';
import { APP_DATE_FORMATS, AppDateAdapter } from 'app/format-datepicker';
// import { SharedDataService } from 'app/shared-data.service';

@Component({
  selector: 'app-prepaid-services',
  templateUrl: './prepaid-services.component.html',
  styleUrls: ['./prepaid-services.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }
  ]
})
export class PrepaidServicesComponent implements OnInit {

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() private prePaidRef: MatDialogRef<PrepaidServicesComponent>,
    private dialog: MatDialog,
    public sanitizer: DomSanitizer,
    private pageTitleService: PageTitleService,
    public router: Router,
    public sharedDataService: SharedDataService,
  ) { }

  @ViewChild('prepStep') prepStep: MatHorizontalStepper;
  @ViewChild('transactionModal') transactionModal: MatHorizontalStepper;
  @ViewChild('SelfTransaction') SelfTransaction: TemplateRef<any>;
  @ViewChild('servicesPackages') servicesPackages: TemplateRef<any>;
  SelfTransactionDialog: MatDialogRef<any>;
  servicesPackagesDialog: MatDialogRef<any>;
  // private mainComponent: MainComponent,
  // public IndexedDbStore: IndexedDbStorageService,

  public get schoolClassroomsCache() {
    return sessionStorage.getItem('schoolClassrooms');
  }

  public get roles() {
    return sessionStorage.getItem('roles');
  }
  public get school_id(): any {
    return sessionStorage.getItem('school_id');
  }

  selectedClassroom: any[] = []
  SchoolClassroom = []
  SchoolStudentsList: any[] = []
  schoolEmployeesList = []
  schoolLegalGuardianList = []
  schoolEmployeesListBackup = []
  schoolTerms = []
  schoolAgreementForFeature: any
  on
  pageStepper = 0
  startDateModel2
  fromProfile: boolean
  endDateModel2
  selectedTerm2
  startDateModel = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
  endDateModel = moment().endOf('month').format('YYYY-MM-DD')
  myExhaustiveSubscription = []
  async ngOnInit() {
    this.getPermissions(JSON.parse(this.sharedDataService.roles));
    await this.mergeActiveAgreementsAndPrepaids()
    this.getMomo();
    this.SchoolClassroom = [...JSON.parse(this.schoolClassroomsCache || '[]')].filter(item=>!item.Classroom_Name.toLowerCase().includes("training") && !item.Classroom_Name.toLowerCase().includes("unknown"))
    if (this.selectedClassroom.length == this.SchoolClassroom.length) {
      this.on = true
    }

    if (!this.data) {
      this.sharedDataService.setColor();
      this.isFeaturesList = true
      this.pageStepper = 0
      this.schoolEmployeesList = this.sharedDataService.schoolEmployeesCache ? [...JSON.parse(this.sharedDataService.schoolEmployeesCache)] : []
      this.schoolEmployeesList.forEach(item => {
        
        if (item.School_Employee_Identifier == this.sharedDataService.emp_Id) {
          item.isUserSelected = true
        }
      })
      this.schoolEmployeesList = this.schoolEmployeesList.sort((a, b) => {
        if (a.Full_Name2 === this.sharedDataService.user_full_name) return -1;
        if (b.Full_Name2 === this.sharedDataService.user_full_name) return 1;

        return a.Full_Name2.localeCompare(b.Full_Name2);
      });
      const includedClasses = this.SchoolClassroom.map(item=>item.Classroom_Identifier)
      this.improvCount = this.schoolEmployeesList.some(item => item.isUserSelected) ? 1 : 0
      this.schoolEmployeesListBackup = this.schoolEmployeesList
      this.schoolLegalGuardianList = this.sharedDataService.duplicateSchoolStudents ? [...JSON.parse(this.sharedDataService.duplicateSchoolStudents)] : []
      this.SchoolStudentsList = this.sharedDataService.activeSchoolStudents ? [...JSON.parse(this.sharedDataService.activeSchoolStudents)].filter(item=>includedClasses.includes(item.Classroom_Identifier)) : []
      if(!this.SchoolStudentsList.length){
        this.sharedDataService.celebrate("No Students Found");
        window.history.back();
        return;
      }
      this.getExhaustiveFeatures()
      if (window.location.href.includes("school-subscriptions")) {
        this.serviceType="Renewal"
        if(window.location.href.includes("renewal")){
          this.directRedirect=true
        }
        if (!this.canViewSchoolPackages) {
          // window.history.back()
          setTimeout(() => {
            this.sharedDataService.showAlert("Permission Not Found", "Sorry you do not have permission to access this feature", () => { window.history.back() }, () => { }, "Okay", "")
          }, 300);
          return
        }
        this.pageTitleService.setTitle("Administration ~ Subscriptions")
        this.getSchoolPackages(true);
        this.fromProfile = false
      } else {
        this.pageTitleService.setTitle("Subscriptions")
        this.fromProfile = true
        this.serviceType="Feature"
        this.mySubscriptionPageIndex = 0
      }
    }

    if (this.data) {
      this.FetchClientVideo(this.data.feature)
      this.selectedClassroom = this.data.classroom
      if (this.data.school_employees.length) {
        this.data.school_employees[0].isUserSelected = true
      }
      this.schoolEmployeesList = this.data.school_employees
      this.SchoolStudentsList = this.data.school_students
      this.schoolEmployeesListBackup = this.data.school_employees

      this.pageStepper = 1
      // this.getExhaustiveFeatures()
      this.cartbody.push(
        {
          Client_Application_Resource_Name: this.data.feature,
          Client_Application_Resource_Display_Name: '',
          Client_Application_Resource_Identifier: this.resolveClientResourceID(this.data.feature),
          purchased_by: this.sharedDataService.user_full_name,
          purchased_personId: this.sharedDataService.user_id,
          Help_Video_Url: "",
          isSel: false,
        }
      )
      this.handleLoging()
    }

    if (this.sharedDataService.schoolTermsCache) {
      this.schoolTerms = [...JSON.parse(this.sharedDataService.schoolTermsCache)]
      this.schoolTerms.forEach(item => {
        if (item.Current_Term_Indicator == 1) {
          this.selectedTerm2 = item
          this.setDates2(item)

        }
      })
    }


  }
  resolveClientResourceID(uiName) {
    let id = null;
    let permissions = this.roles ? JSON.parse(this.roles) : [];
    permissions.forEach(element => {
      if (element.Client_Application_Resource_Name == uiName) {
        // 
        // id = 'UI ID';
        id = element.Client_Application_Resource_Identifier;
      }
    });
    return id;
  }

  selectAllClass() {
    if (this.on == true) {
      this.selectedClassroom = [];
      this.on = false;
    }
    else {
      this.selectedClassroom = [];
      this.SchoolClassroom.forEach((schoolClass, index) => {
        this.selectedClassroom.push(schoolClass.Classroom_Identifier)
      });
      this.on = true;
    }
    this.changesMadePackage = true
  }

  gottoNext(id) {
    this.prepStep.selectedIndex = id
    setTimeout(() => {
      var filter = document.querySelectorAll('#tHalf')
      for (var i = 0; i <= filter.length - 1; i++) {
        if (i == id) {
          filter[i].classList.add("paginateActive")
        } else {
          filter[i].classList.remove("paginateActive")
        }
      }
    }, 300);
  }


  stepperIndex = 0
  selectedUsers = []
  filterClassList = []
  forViewingList: any = { "classroom_names": [], "person_names": [], 'classroom': false, "person": false }
  onSelectionChange(e: any) {
    const index = e.selectedIndex;
    this.stepperIndex = e.selectedIndex;
    // if (index === 1) {
    //   this.filterClassList = this.SchoolClassroom.filter(item=>this.selectedClassroom.includes(item.Classroom_Identifier))
    //   this.forViewingList['classroom_names']= this.filterClassList.map(item=>item.Classroom_Name)
    //   this.packageContent[0][2]=`<label style="margin:0;font-weight:600 !important;">Available for:</label> ${this.summaryText(this.filterClassList.map(item=>item.Classroom_Name),1,'text')}`
    //   this.packageContent[1][2]=`<label style="margin:0;font-weight:600 !important;">Available for:</label> ${this.summaryText(this.filterClassList.map(item=>item.Classroom_Name),1,'text')}`
    //   this.packageContent[2][2]=`<label style="margin:0;font-weight:600 !important;">Available for:</label> ${this.summaryText(this.filterClassList.map(item=>item.Classroom_Name),1,'text')}`

    //   // this.prePaidRef.updateSize('600px');
    // } else if (index === 2) {
    //   // this.prePaidRef.updateSize('60%');
    //   this.forViewingList['person_names']= this.selectedUsers.map(item=>item.Full_Name2)
    //   this.selectedUsers = this.schoolEmployeesList.filter(emp=>emp.isUserSelected)
    //   this.packageContent[0][3]=`<label style="margin:0;font-weight:600 !important;">Accessible by:</label> ${this.summaryText(this.selectedUsers.map(item=>item.Full_Name2),1,'text')}`
    //   this.packageContent[1][3]=`<label style="margin:0;font-weight:600 !important;">Accessible by:</label> ${this.summaryText(this.selectedUsers.map(item=>item.Full_Name2),1,'text')}`
    //   this.packageContent[2][3]=`<label style="margin:0;font-weight:600 !important;">Accessible by:</label> ${this.summaryText(this.selectedUsers.map(item=>item.Full_Name2),1,'text')}`
    // }
  }

  currentPackage: any = {
    "Option_Duration": "",
    "Option_Name": '',
    'Caculated_Raw_Price': '',
    "Price_After_Discount": "",
    "Tax": "",
  }
  packageContent = []
  selectedContent = []
  packageSel(val, index) {
    this.currentPackage = val
    this.selectedContent = this.packageContent[index]
  }

  getSafeHtml(content: string) {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }
  preventExpansion(event: Event): void {
    event.stopPropagation();
  }

  ProcessInitiation = false
  startProcess() {
    this.stepperIndex = 3
    // this.prePaidRef.updateSize('85%');
    this.ProcessInitiation = true
    const searchDefaultMtn = this.serviceProviders.find((telcos: any) => (telcos.Payment_Service_Provider_Name.toLowerCase().includes('mtn') && telcos.isInCountry)) || this.serviceProviders.find(telcos => (telcos.Payment_Service_Provider_Name.toLowerCase().includes('card') && telcos.isInCountry))
    this.assignMethod(searchDefaultMtn ? { ...searchDefaultMtn, 'Payer_Payee': this.sharedDataService.user_full_name } : this.serviceProviders[1])
  }

  assignMethod(val) {
    this.selectedTransMethod = { ...val, 'Payer_Payee': this.sharedDataService.user_full_name }
  }

  improvCount = 1
  sellAllEmp: boolean
  selectStudentPush(employee, index) {
    employee.isUserSelected = !employee.isUserSelected
    if (employee.isUserSelected) {
      this.improvCount++
    } else {
      this.improvCount--
    }
    this.schoolEmployeesListBackup[index] = employee
  }

  selectAllEmp(val) {
    requestAnimationFrame(() => {
      if (val != true) {
        this.schoolEmployeesList.forEach(emp => {
          emp.isUserSelected = false
        });
        this.schoolEmployeesListBackup.forEach(emp => {
          emp.isUserSelected = false
        })
        // this.sellAllEmp = false;
      }
      else {
        this.schoolEmployeesList.forEach(emp => {
          emp.isUserSelected = true
        })
        this.schoolEmployeesListBackup.forEach(emp => {
          emp.isUserSelected = true
        })
        // this.sellAllEmp = true;
      }
    })
  }



  find(event) {
    let text = event.target.value.toLowerCase();
    if (text) {
      this.schoolEmployeesList = this.schoolEmployeesListBackup.filter(employee => employee.Full_Name2.toLowerCase().includes(text))
    } else {
      this.schoolEmployeesList = this.schoolEmployeesListBackup
    }
  }

  selectedBaseEmployees = []
  shiftview(action, ind, increment = 0) {

    this.stepperIndex = ind
    if (ind < 3) {
      this.ProcessInitiation = false
      this.isFeaturesList = false
      setTimeout(() => {
        try {
          this.prepStep.selectedIndex = ind
          var filter = document.querySelectorAll('#tHalf')
          for (var i = 0; i <= filter.length - 1; i++) {
            if (i == ind + increment) {
              filter[i].classList.add("paginateActive")
            } else {
              filter[i].classList.remove("paginateActive")
            }
          }
        } catch (error) {

        }
      }, 300);
      this.selectedBaseEmployees = this.schoolEmployeesList.filter(item => item.isUserSelected)
    } else {
      this.ProcessInitiation = true
    }
    var filter = document.querySelectorAll('#tHalf')
    for (var i = 0; i <= filter.length - 1; i++) {
      if (i == ind + increment) {
        filter[i].classList.add("paginateActive")
      } else {
        filter[i].classList.remove("paginateActive")
      }
    }
  }

  summaryText(list: any[], limit: number, type: string, layout?) {
    if (!layout) {
      let listString = list.slice(0, limit).join(', ')
      let balance = list.length - limit
      if (balance > 0) {
        let mergeStr = ` <strong style="font-weight:600 !important;color:var(--schcol)">, + ${balance} more</strong>`
        return type == 'html' ? this.getSafeHtml(listString + mergeStr) : listString + mergeStr
      } else {
        // let mergeStr = `<strong style="font-weight:600 !important;color:var(--schcol)">+ ${balance}</strong>`
        return type == 'html' ? this.getSafeHtml(listString) : listString
      }
    }
  }


  async getExhaustiveFeatures(callsCart?) {
    this.isLoadingFeatures = true
    const url = `/platform/clientapplicationresources?${this.sharedDataService.getActivityForUrl()}`;
    if (this.allSimsFeatures.length) {
      this.isLoadingFeatures = false
      return
    }
    await this.sharedDataService.getHttp(url).toPromise().then(
      res => {
        this.isLoadingFeatures = false
        
        this.isLoadingFeatures = false
        const clientIds = this.schoolAgreementForFeature ? this.schoolAgreementForFeature.ActivePurchasedFeatures.map(({ Client_Application_Resource_Identifier, Prepaid_Service_Transaction_Identifier }) => { return { Client_Application_Resource_Identifier, Prepaid_Service_Transaction_Identifier } }) : []
        let result: any = Array.isArray(res.json()) ? res.json() : []
        if (!result.length) {
          return
        }

        result = result.filter(resource => resource.Visible_On_Prepaid_Services == 1 || resource.Client_Application_Resource_Module == "Module")
        result.forEach(resource => {
          resource['inSchoolPackage'] = clientIds.find(id => id.Client_Application_Resource_Identifier == resource.Client_Application_Resource_Identifier && !id.Prepaid_Service_Transaction_Identifier) ? true : false
          resource['inSubscription'] = clientIds.find(id => id.Client_Application_Resource_Identifier == resource.Client_Application_Resource_Identifier && id.Prepaid_Service_Transaction_Identifier) ? true : false

          if (clientIds.map(item => item.Client_Application_Resource_Identifier).includes(resource.Client_Application_Resource_Identifier)) {
            
          }
        });
        // result = result.filter(clientnames => !clientIds.includes(clientnames.Client_Application_Resource_Identifier))
        // this.allSimsModules = result.filter(item=>item.Client_Application_Resource_Module.toLowerCase()=="module")
        // this.allSimsModules = result.filter(item=>item.Client_Application_Resource_Module.toLowerCase()=="module").map(item=>item.Client_Application_Resource_Name)
        this.prepareFeaturesList(result, callsCart)
      }, err => {
        this.isLoadingFeatures = false
        this.isFailureFeuatures = err.json()
      }
    )
  }

  prepareFeaturesList(list, cart?: any[]) {
    this.allSimsFeatures = list.reduce((prev, curr) => {
      if (prev.find(item => item.Client_Application_Resource_Module == curr.Client_Application_Resource_Module && curr.Client_Application_Resource_Module != "Module")) {
        prev.find(item => {
          if (item.Client_Application_Resource_Module == curr.Client_Application_Resource_Module && curr.Client_Application_Resource_Module != "Module") {
            item.GroupedFeatures.push(curr)
            item.Has_Classroom_Filter_Array.push(curr.Has_Classroom_Filter)
            // item.Has_Classroom_Filter_Array =  _.uniq(item.Has_Classroom_Filter)
            item.GroupedFeatures = sortBy(item.GroupedFeatures, 'Client_Application_Resource_Name')

          }
        })
      } else {
        if (curr.Client_Application_Resource_Module != "Module" && curr.Client_Application_Resource_Module && curr.Client_Application_Resource_Module != " ") {
          prev.push(
            {
              Client_Application_Resource_Module: curr.Client_Application_Resource_Module,
              Has_Classroom_Filter_Array: [curr.Has_Classroom_Filter],
              GroupedFeatures: [curr],
            }
          )
        }
      }

      return prev
    }, [])
    this.allSimsFeatures.forEach(item => {
      let currentAccumulator = 0; // Temporary counter for the accumulator

      item.GroupedFeatures.forEach(feat => {
        if (this.cartbody && this.cartbody.length > 0) {
          if (this.cartbody.find(shop => shop.Client_Application_Resource_Name === feat.Client_Application_Resource_Name)) {
            feat.addedToCart = true;
            currentAccumulator++; // Increase the accumulator if item is in cart
          } else {
            feat.addedToCart = false;
          }
        } else {
          feat.addedToCart = false;
        }
      });

      item.isAccumulator = currentAccumulator;
      item.isModuleSelected = item.isAccumulator > 0; // Set isModuleSelected based on isAccumulator
    });
    // this.filterFeaturesList()

    this.allSimsFeatures = sortBy(this.allSimsFeatures, 'Client_Application_Resource_Module')
    this.allSimsFeaturesBackup = this.allSimsFeatures
  }

  filterFeaturesList() {
    const selectedModules = this.allSimsFeaturesBackup.filter(item => item.isModuleSelected).map(item => item.Client_Application_Resource_Module)
    if (selectedModules.length) {
      this.allSimsFeatures = this.allSimsFeaturesBackup.filter(item => selectedModules.includes(item.Client_Application_Resource_Module))
    } else {
      this.allSimsFeatures = this.allSimsFeaturesBackup
    }
  }

  deleteMultiple: boolean
  allModuleFeaturesSelected(list) {
    list = list.filter(item => this.hasClassFilter == null || item.Has_Classroom_Filter == this.hasClassFilter)
    return list.every(item => item.addedToCart)
  }

  allCartItemSelected() {
    return this.cartbody.every(item => !item.isSel)
  }



  findFeature(event) {
    let text = event.target.value.toLowerCase();
    this.allSimsFeatures = this.allSimsFeaturesBackup
      .map(item => {
        const matchesModule = item.Client_Application_Resource_Module ? item.Client_Application_Resource_Module.toLowerCase().includes(text.toLowerCase()) : false;
        const matchingFeatures = item.GroupedFeatures.filter(feature =>
          feature.Client_Application_Resource_Name.toLowerCase().includes(text.toLowerCase())
        );

        // Only return the item if there are matching features or if the module matches
        if (matchesModule) {
          return {
            ...item,
            GroupedFeatures: item.GroupedFeatures
          };
        }
        if (matchingFeatures.length > 0) {
          return {
            ...item,
            GroupedFeatures: matchingFeatures
          };
        }
        return null;
      }).filter(item => item != null)

    if (!text) {
      this.filterFeaturesList()
    }

  }

  scrollToParagraph(id) {
    try {
      const docPep = document.getElementById(id + "_feat").scrollIntoView({ behavior: 'smooth', block: 'start' });
      
    } catch (error) {
      
    }
  }

  private hoverTimer: any;
  startHoverTimer(feature): void {
    // Start a timer for 2 minutes (120000 milliseconds)
    this.hoverTimer = setTimeout(() => {
      feature.showPopOver = true;
    }, 900); // 2 minutes in milliseconds
  }

  resetHoverTimer(feature): void {
    // Reset the timer if the mouse leaves the element
    clearTimeout(this.hoverTimer);
    this.hoverTimer = null
    feature.showPopOver = null;
  }

  async pathMapping(path) {
    // this.prePaidRef.updateSize('82%',"100%");
    if (path == 0) {
      this.viewPrepaid()
      this.handleLoging('navigates to add more features')
    } else if (path == 1 || path == 2) {
      this.pageStepper = path
      setTimeout(() => {
        this.shiftview('', path - 1, 1)
        this.handleLoging(`navigates to ${path == 1 ? 'Classroom Step' : 'User Step'}`)
      }, 300);
    } else if (path == 3) {
      this.isFeaturesList = false
      this.ProcessInitiation = false
      this.stepperIndex = this.pageStepper - 1
      this.pageStepper = 3
      this.calculatePacakage()
      this.handleLoging(`navigates to package duration and pricing option`)


      setTimeout(() => {
        this.shiftview('', path - 1, 1)
      }, 300);
    } else if (path == 4) {
      this.pageStepper = path
      this.stepperIndex = 3
      this.handleLoging(`navigates to product review step (Cart)`)

      this.isFeaturesList = false
      this.ProcessInitiation = true
      setTimeout(() => {
        this.transactionModal.selectedIndex = 0
        if (this.changesMadePackage) {
          // this.changesMadePackage=false
          this.calculatePacakage(this.currentPackage.Prepaid_Service_Pricing_Option_Identifier)
        }

        if (!this.currentPackage.Caculated_Raw_Price) {
          this.calculatePacakage()
        }
        this.shiftview('', path - 1, 1)
      }, 300);
    } else if (path == 5) {
      // this.prePaidRef.updateSize('95vw',"100%");
      this.pageStepper = path
      this.stepperIndex = 3
      this.isFeaturesList = false
      this.ProcessInitiation = true
      setTimeout(() => {
        this.handleLoging(`navigates to checkout and payment step`)
        try {
          if (this.singleFeatureFound.Has_Classroom_Filter == 0 || this.hasClassFilter == 0) {
            this.selectedClassroom = this.SchoolClassroom.map(clss => clss.Classroom_Identifier)
          }

          const searchDefaultMtn = this.serviceProviders.find((telcos: any) => (telcos.Payment_Service_Provider_Name.toLowerCase().includes('mtn') && telcos.isInCountry)) || this.serviceProviders.find(telcos => (telcos.Payment_Service_Provider_Name.toLowerCase().includes('card') && telcos.isInCountry))
          this.assignMethod(searchDefaultMtn ? { ...searchDefaultMtn, 'Payer_Payee': this.sharedDataService.user_full_name } : this.serviceProviders[1])
        } catch (error) {

        }
        this.transactionModal.selectedIndex = 1
        if (this.changesMadePackage) {
          // this.changesMadePackage=false
          this.calculatePacakage(this.currentPackage.Prepaid_Service_Pricing_Option_Identifier)
        }
        if (!this.currentPackage.Caculated_Raw_Price) {
          this.calculatePacakage()
        }
        this.shiftview('', path - 1, 1)
      }, 300);
    }
  }

  processStep() {
    if (this.pageStepper == 0) {
      this.isFeaturesList = true
      this.shiftview('', this.pageStepper, 1)
      this.handleLoging(`navigates to ${'Classroom Step'}`)
      this.pageStepper++
    } else if (this.pageStepper == 1 || this.pageStepper == 2) {
      // if(!this.isFeaturesList){
      // }
      if (this.pageStepper == 1) {
        if (this.singleFeatureFound.Has_Classroom_Filter == 0 || this.hasClassFilter == 0) {
          this.selectedClassroom = this.SchoolClassroom.map(clss => clss.Classroom_Identifier)
        }
        this.handleLoging(`navigates to ${'User Step'}`)
      }



      this.isFeaturesList = false
      this.ProcessInitiation = false
      this.stepperIndex = this.pageStepper - 1

      setTimeout(() => {
        if (this.pageStepper == 2) {
          this.calculatePacakage()
          this.handleLoging(`navigates to package duration and pricing option`)

        }
        this.shiftview('', this.pageStepper, 1)
        this.pageStepper++
      }, 300);
    } else if (this.pageStepper == 3) {
      this.stepperIndex = 3
      this.isFeaturesList = false

      this.ProcessInitiation = true

      setTimeout(() => {
        this.handleLoging(`navigates to product review step (Cart)`)
        this.pageStepper++
        this.transactionModal.selectedIndex = 0
        this.shiftview('', this.pageStepper)
      }, 300);


      const searchDefaultMtn = this.serviceProviders.find((telcos: any) => (telcos.Payment_Service_Provider_Name.toLowerCase().includes('mtn') && telcos.isInCountry)) || this.serviceProviders.find(telcos => (telcos.Payment_Service_Provider_Name.toLowerCase().includes('card') && telcos.isInCountry))
      this.assignMethod(searchDefaultMtn ? { ...searchDefaultMtn, 'Payer_Payee': this.sharedDataService.user_full_name } : this.serviceProviders[1])
      // this.assignMethod(this.serviceProviders[1])
      // this.pageStepper++
    } else if (this.pageStepper == 4) {
      // this.prePaidRef.updateSize('95vw',"100%");
      // this.prePaidRef.updatePosition()
      this.isFeaturesList = false
      setTimeout(() => {
        this.handleLoging(`navigates to checkout and payment step`)
        this.transactionModal.selectedIndex = 1
        this.shiftview('', this.pageStepper, 1)
        this.pageStepper++
      }, 300);

      // this.ProcessInitiation=true
    }
  }

  decreaseStep() {
    // this.prePaidRef.updateSize('82%',"100%");
    if (this.pageStepper == 0) {
      if (this.pageStepper == 0 && this.data) {
        this.callLogingSteps()
        this.prePaidRef.close()
        return this.pageStepper = 0
      } else {
        this.isFeaturesList = false
        this.mySubscriptionPageIndex = 0
        this.currentPackage = {
          "Option_Duration": "",
          "Option_Name": '',
          'Caculated_Raw_Price': '',
          "Price_After_Discount": "",
          "Tax": "",
        }
        this.callLogingSteps()
      }
      this.pageStepper
      // this.processStep()
    } else if (this.pageStepper == 1) {
      if (this.pageStepper == 1 && this.data) {
        this.callLogingSteps()
        this.prePaidRef.close()
        return this.pageStepper = 1
      } else {
        this.pageStepper = 0
        this.isFeaturesList = true
        setTimeout(() => {
          try {
            // this.prepStep.selectedIndex=this.prepStep
            var filter = document.querySelectorAll('#tHalf')
            for (var i = 0; i <= filter.length - 1; i++) {
              if (i == this.pageStepper) {
                filter[i].classList.add("paginateActive")
              } else {
                filter[i].classList.remove("paginateActive")
              }
            }
          } catch (error) {

          }
        }, 300);
      }
    } else if (this.pageStepper == 2) {

      // this.assignMethod(this.paymentList[1])
      this.ProcessInitiation = false
      this.stepperIndex = 0
      this.pageStepper = 1
      setTimeout(() => {
        this.pageStepper = 1
        this.handleLoging(`navigates to ${'Classroom Step'}`)
        this.shiftview('lHalf', 0, 1)
      }, 300);

    } else if (this.pageStepper == 3) {
      this.ProcessInitiation = false
      this.stepperIndex = 1
      setTimeout(() => {
        this.pageStepper = 2
        this.handleLoging(`navigates to ${'User Step'}`)
        this.shiftview('lHalf', 1, 1)
      }, 300);
    } else if (this.pageStepper == 4) {
      this.stepperIndex = 3
      this.ProcessInitiation = false
      this.isFeaturesList = false
      setTimeout(() => {
        this.transactionModal.selectedIndex = 0
        this.pageStepper = 3
        if (this.changesMadePackage) {
          this.changesMadePackage = false
          this.handleLoging(`navigates to package duration and pricing option`)
          this.calculatePacakage()
        }
        this.shiftview('', this.pageStepper - 1, 1)
      }, 300);
    } else if (this.pageStepper == 5) {
      this.stepperIndex = 3
      this.ProcessInitiation = true
      this.isFeaturesList = false
      setTimeout(() => {
        this.pageStepper = 4
        this.handleLoging(`navigates to product review step (Cart)`)
        this.transactionModal.selectedIndex = 0
        this.shiftview('', this.pageStepper)
      }, 300);
    }
  }

  async viewPrepaid() {
    this.allSimsFeatures.forEach(item => {
      let currentAccumulator = 0; // Temporary counter for the accumulator

      item.GroupedFeatures.forEach(feat => {
        if (this.cartbody && this.cartbody.length > 0) {
          if (this.cartbody.find(shop => shop.Client_Application_Resource_Name === feat.Client_Application_Resource_Name)) {
            feat.addedToCart = true;
            currentAccumulator++; // Increase the accumulator if item is in cart
          } else {
            feat.addedToCart = false;
          }
        } else {
          feat.addedToCart = false;
        }
      });

      item.isAccumulator = currentAccumulator;
      item.isModuleSelected = item.isAccumulator > 0 || item.isModuleSelected; // Set isModuleSelected based on isAccumulator
    });
    this.isFeaturesList = true
    this.ProcessInitiation = false
    this.pageStepper = 0
    this.handleLoging('navigates to add more features')
    setTimeout(() => {
      try {
        // this.prepStep.selectedIndex=this.prepStep
        var filter = document.querySelectorAll('#tHalf')
        for (var i = 0; i <= filter.length - 1; i++) {
          if (i == this.pageStepper) {
            filter[i].classList.add("paginateActive")
          } else {
            filter[i].classList.remove("paginateActive")
          }
        }
      } catch (error) {

      }
    }, 300);
    await this.getExhaustiveFeatures(this.cartbody)
    // this.prepareFeaturesList(this.allSimsFeatures,this.cartbody)
  }

  BulkDeletItem() {
    this.changesMadePackage = true
    this.cartbody = this.cartbody.filter(item => !item.isSel)
    this.calculatePacakage(this.currentPackage.Prepaid_Service_Pricing_Option_Identifier)
  }

  ToggleGroupToCart(list: any[]) {
    list = list.filter(item => this.hasClassFilter == null || item.Has_Classroom_Filter == this.hasClassFilter)
    const AllvalSel = this.allModuleFeaturesSelected(list)
    list.forEach(feature => {
      if (AllvalSel) {
        this.cartbody = this.cartbody.filter(item => item.Client_Application_Resource_Name != feature.Client_Application_Resource_Name)
      } else {
        this.cartbody.push({
          ...feature
        })
      }
    })

    this.allSimsFeatures.forEach(item => {
      let currentAccumulator = 0; // Temporary counter for the accumulator

      item.GroupedFeatures.forEach(feat => {
        if (this.cartbody && this.cartbody.length > 0) {
          if (this.cartbody.find(shop => shop.Client_Application_Resource_Name === feat.Client_Application_Resource_Name)) {
            feat.addedToCart = true;
            currentAccumulator++; // Increase the accumulator if item is in cart
          } else {
            feat.addedToCart = false;
          }
        } else {
          feat.addedToCart = false;
        }
      });

      item.isAccumulator = currentAccumulator;
      item.isModuleSelected = item.isAccumulator > 0 || item.isModuleSelected; // Set isModuleSelected based on isAccumulator
    });

    this.allSimsFeatures = sortBy(this.allSimsFeatures, 'Client_Application_Resource_Module')
    // this.allSimsFeaturesBackup = this.allSimsFeatures
    this.filterFeaturesList()
    this.changesMadePackage = true
  }


  AddremoveResource(shop, calc?) {
    if (this.cartbody.find(item => item.Client_Application_Resource_Name == shop.Client_Application_Resource_Name)) {
      this.cartbody = this.cartbody.filter(item => item.Client_Application_Resource_Name != shop.Client_Application_Resource_Name)
      if (!this.cartbody.length) {
        this.hasClassFilter = null
      }
    } else {
      this.hasClassFilter = shop.Has_Classroom_Filter
      this.cartbody.push({
        ...shop
      })
    }
    this.changesMadePackage = true

    this.allSimsFeatures.forEach(item => {
      let currentAccumulator = 0; // Temporary counter for the accumulator

      item.GroupedFeatures.forEach(feat => {
        if (this.cartbody && this.cartbody.length > 0) {
          if (this.cartbody.find(shop => shop.Client_Application_Resource_Name === feat.Client_Application_Resource_Name)) {
            feat.addedToCart = true;
            currentAccumulator++; // Increase the accumulator if item is in cart
          } else {
            feat.addedToCart = false;
          }
        } else {
          feat.addedToCart = false;
        }
      });

      item.isAccumulator = currentAccumulator;
      item.isModuleSelected = item.isAccumulator > 0 || item.isModuleSelected; // Set isModuleSelected based on isAccumulator
    });

    this.allSimsFeatures = sortBy(this.allSimsFeatures, 'Client_Application_Resource_Module')
    // this.allSimsFeaturesBackup = cloneDeep(this.allSimsFeatures)
    this.filterFeaturesList()
    if (calc) {
      this.calculatePacakage(this.currentPackage.Prepaid_Service_Pricing_Option_Identifier)
    }
  }

  isFetchingPackage: boolean = false
  recommendedPack: any = { Price_After_Discount: 0 }
  changesMadePackage: boolean
  countDuration = 0
  calculatePacakage(packageId?) {
    this.isFetchingPackage = true
    this.packagesList = []
    let url = `/micro_pricing/price_calculation`

    let body = {
      "prepaid_service_transactions": [],
      "country": this.schoolAgreementForFeature.country,
      "Prepaid_Service_Currency": this.schoolAgreementForFeature.Invoice_Currency
    }
    if (packageId) {
      body['prepaid_service_pricing_option'] = packageId
    }

    this.cartbody.forEach((item, where) => {
      body.prepaid_service_transactions.push(
        cloneDeep(
          {
            "Client_Application_Resource_Identifier": this.resolveClientResourceID(item.Client_Application_Resource_Name),
            "Prepaid_Service_Transaction_Total_Classroom_Students": 0,
            "Prepaid_Service_Transaction_Total_Users": this.schoolEmployeesList.filter(employees => employees.isUserSelected).length
          }
        )
      )
      this.selectedClassroom.forEach(classids => {
        body.prepaid_service_transactions[where].Prepaid_Service_Transaction_Total_Classroom_Students += this.SchoolStudentsList.filter(classStudents => classStudents.Classroom_Identifier == classids).length
      })
    })

    this.sharedDataService.postHttp(url, body).toPromise().then(
      res => {
        this.isFetchingPackage = false
        this.changesMadePackage = false
        
        const results = res.json()
        if (!packageId) {
          this.packagesList = results.prices
          this.servicePrices = results.prepaid_service_transactions
          this.currentPackage = this.packagesList.find(item => item.Recommend_Option_Indicator)
          this.recommendedPack = cloneDeep(this.currentPackage)
          this.filterClassList = this.SchoolClassroom.filter(item => this.selectedClassroom.includes(item.Classroom_Identifier))
          this.forViewingList['classroom_names'] = this.filterClassList.map(item => item.Classroom_Name)
          this.selectedUsers = this.schoolEmployeesList.filter(emp => emp.isUserSelected)
          this.forViewingList['person_names'] = this.selectedUsers.map(item => item.Full_Name2)

          this.packagesList.forEach((packs, index) => {
            packs.Option_Order = parseInt(packs.Option_Order)
            this.packageContent[index] = [`<label style="margin:0;font-weight:600 !important;">Feature: <span style="color:var(--schcol)">${this.summaryText(this.cartbody.map(carts => carts.Client_Application_Resource_Name), 1, 'text')}</span></label>`]
            this.packageContent[index].push(`Subscription for a ${packs.Option_Duration} day(s) period`)
            this.packageContent[index].push(`<label style="margin:0;font-weight:600 !important;">Available for:</label> ${this.summaryText(this.filterClassList.map(item => item.Classroom_Name), 1, 'text')}`)

            this.packageContent[index].push(`<label style="margin:0;font-weight:600 !important;">Accessible by:</label> ${this.summaryText(this.selectedUsers.map(item => item.Full_Name2), 1, 'text')}`)
            if (this.currentPackage.Prepaid_Service_Pricing_Option_Identifier == packs.Prepaid_Service_Pricing_Option_Identifier) {
              this.selectedContent = this.packageContent[index]
            }
          })
          this.packagesList = sortBy(this.packagesList, 'Option_Order')
        } else {
          this.currentPackage = results.prices[0]
        }

      }, async (err) => {
        this.isFetchingPackage = false
        this.sharedDataService.celebrate('Could not calculate elements please check network.')
        this.countDuration++
        if (this.countDuration <= 3) {
          await new Promise((resolve: any) => { setTimeout(() => resolve(), 1000) })
          this.pathMapping(3)
        }
      }
    )
  }

  selectedPackageUpgradeRenew
  calculatePacakage2(packageId?) {
    this.selectedPackageUpgradeRenew = packageId
    this.isFetchingPackage = true
    this.packagesList = []
    let url = `/micro_pricing/price_calculation`

    let body = {
      "Service_Package_Id": packageId.Service_Package_Identifier,
      "Total_Students": this.SchoolStudentsList.length,
      "School_Id": parseInt(this.sharedDataService.school_id),
      "Service_Type": this.serviceType
    }


    this.sharedDataService.postHttp(url, body).toPromise().then(
      res => {
        this.isFetchingPackage = false
        
        const results = res.json()
        this.packagesList = results
        // this.servicePrices = results.prepaid_service_transactions
        this.currentPackage = this.packagesList.find(item => item.Recommend_Option_Indicator)
        this.recommendedPack = cloneDeep(this.currentPackage)
        this.filterClassList = this.SchoolClassroom.filter(item => this.selectedClassroom.includes(item.Classroom_Identifier))
        this.forViewingList['classroom_names'] = this.filterClassList.map(item => item.Classroom_Name)
        this.selectedUsers = this.schoolEmployeesList.filter(emp => emp.isUserSelected)
        this.forViewingList['person_names'] = this.selectedUsers.map(item => item.Full_Name2)

        this.packagesList.forEach((packs, index) => {
          packs.Option_Order = parseInt(packs.Option_Order)
          this.packageContent[index] = [`<label style="margin:0;font-weight:600 !important;">Name: <span style="color:var(--schcol)">${packageId.Package_Name + '(' + this.serviceType + ')'}</span></label>`]
          this.packageContent[index].push(`<label style="margin:0;font-weight:600 !important;"><span style="color:var(--schcol)">${this.SchoolCurrentPackage.Desc}</span></label>`)
          this.packageContent[index].push(`Subscription for a ${packs.Option_Duration} day(s) period`)
          this.packageContent[index].push(`<label style="margin:0;font-weight:600 !important;">Available for:</label> All classrooms`)

          this.packageContent[index].push(`<label style="margin:0;font-weight:600 !important;">Accessible by:</label> All employees`)
          if (this.currentPackage.Prepaid_Service_Pricing_Option_Identifier == packs.Prepaid_Service_Pricing_Option_Identifier) {
            this.selectedContent = this.packageContent[index]
          }
        })
        this.packagesList = sortBy(this.packagesList, 'Option_Order')


      }, async (err) => {
        this.isFetchingPackage = false
        this.sharedDataService.celebrate('Could not calculate elements please check network.')
        // this.countDuration++
        // if (this.countDuration <= 3) {
        //   await new Promise((resolve: any) => { setTimeout(() => resolve(), 1000) })
        //   // this.pathMapping(3)
        // }
      }
    )
  }

  gottoYotube(url) {
    if (url) {
      window.open(url)
    }
  }


  // Transaction payment Procedures
  transaction_fee
  servicePrices
  verifyTransaction_External_Transaction_id
  CentralTransactionPoint() {
    if (this.selectedTransMethod.Payment_Service_Provider_Name.toLowerCase().includes('card')) {
      if (!this.selectedTransMethod.Payer_Payee_Email) {
        return this.sharedDataService.celebrate("Please enter an email");
      }
    }

    if (this.selectedTransMethod.Payment_Service_Provider_Name.toLowerCase().includes('telecel') || this.selectedTransMethod.Payment_Service_Provider_Name.toLowerCase().includes('voda') || this.selectedTransMethod.Payment_Service_Provider_Name.toLowerCase().includes('mtn') || this.selectedTransMethod.Payment_Service_Provider_Name.toLowerCase().includes('at money') || this.selectedTransMethod.Payment_Service_Provider_Name.toLowerCase().includes('airtel') || this.selectedTransMethod.Payment_Service_Provider_Name.toLowerCase().includes('tigo')) {
      if (!this.selectedTransMethod.momophone) {
        return this.sharedDataService.celebrate("Please enter an a mobile money number")
      }
    }

    if (!this.selectedClassroom.length) {
      return this.sharedDataService.celebrate('Please Select Classroom(s)')
    }
    if (!this.schoolEmployeesList.filter(item => item.isUserSelected).length) {
      return this.sharedDataService.celebrate('No User(s) have been selected')
    }
    if (!this.currentPackage.Total_Calculated_Price_After_Discount) {
      return this.sharedDataService.celebrate('No amount has been set to be paid')
    }

    const transactionVal = this.currentPackage.Total_Calculated_Price_After_Discount * this.selectedTransMethod.Maximum_Transaction_Fee_Percentage
    if (transactionVal) {
      if (this.selectedTransMethod.Minimum_Transaction_Fee_Amount) {
        if (transactionVal < this.selectedTransMethod.Minimum_Transaction_Fee_Amount) {
          this.transaction_fee = this.selectedTransMethod.Minimum_Transaction_Fee_Amount
        } else {
          this.transaction_fee = transactionVal
        }
      }
      if (this.selectedTransMethod.Maximum_Transaction_Fee_Amount) {
        if (transactionVal > this.selectedTransMethod.Maximum_Transaction_Fee_Amount) {
          this.transaction_fee = this.selectedTransMethod.Minimum_Transaction_Fee_Amount
        } else {
          this.transaction_fee = transactionVal
        }
      }
      if (this.selectedTransMethod.Maximum_Transaction_Fee_Amount && this.selectedTransMethod.Minimum_Transaction_Fee_Amount) {
        if (transactionVal > this.selectedTransMethod.Minimum_Transaction_Fee_Amount && transactionVal < this.selectedTransMethod.Maximum_Transaction_Fee_Amount) {
          this.transaction_fee = transactionVal
        }
      }
    } else {
      this.transaction_fee = 0
    }
    this.failureInit = false
    this.allowUserVerify = false
    const prepaidExternal = {
      "prepaid_service_transactions": [], 
      "Service_Type": "Feature",
      "Service_Price_Exchange_Currency": this.currentPackage.Currency,
      "Service_Price_Exchange_Currency_USD_Rate": this.currentPackage.Service_Price_Exchange_Currency_USD_Rate,
      "GHS_USD_Exchange_Rate": this.currentPackage.GHS_USD_Exchange_Rate,
      "Service_Price_Tax": this.currentPackage.Total_Taxes,
      "Taxes": this.currentPackage.Taxes,
      "Total_Discount_Amount": this.currentPackage.Discount_Value,
      "Subscription_Duration": this.currentPackage.Option_Duration,
      "Total_Subscription_Students": this.SchoolStudentsList.filter(classStudents => this.selectedClassroom.includes(classStudents.Classroom_Identifier)).length,
      "Gross_Price": this.currentPackage.CalCulated_Raw_Price,
      "Service_Package_Expiration_Date": this.currentPackage.Service_Expiration_Date,
      "Agreement_Identifier": this.schoolAgreementForFeature.Agreement_Identifier,
      "Option_Duration": parseInt(this.currentPackage.Option_Duration),
      "Service_Package_Identifier": parseInt(this.schoolAgreementForFeature.Service_Package_Identifier),
      "School_Identifier": parseInt(this.school_id),
      "Created_By": parseInt(this.sharedDataService.user_id)
    }

    this.cartbody.forEach((item, where) => {
      const foundService = this.servicePrices.find(priceID => priceID.Client_Application_Resource_Identifier == this.resolveClientResourceID(item.Client_Application_Resource_Name))
      prepaidExternal.prepaid_service_transactions.push(
        cloneDeep(
          {
            "Client_Application_Resource_Identifier": this.resolveClientResourceID(item.Client_Application_Resource_Name),
            "Client_Application_Resource_Name": item.Client_Application_Resource_Name,
            "Client_Application_Resource_Description": item.Client_Application_Resource_Description,
            "Service_Price": foundService ? (foundService.Service_price * (parseFloat(this.currentPackage.Option_Duration) / 30) + (this.currentPackage.Total_Taxes / this.cartbody.length)) : null,
            "prepaid_Service_transaction_Classroom": [],
            "prepaid_Service_transaction_user": [...this.schoolEmployeesList.filter(employees => employees.isUserSelected).map(empid => { return { "School_Employee_Identifier": empid.School_Employee_Identifier } })]
          }
        )
      )
      this.selectedClassroom.forEach(classids => {
        prepaidExternal.prepaid_service_transactions[where].prepaid_Service_transaction_Classroom.push(cloneDeep({
          "Total_Students_Paid_For": this.SchoolStudentsList.filter(classStudents => classStudents.Classroom_Identifier == classids).length,
          "Classroom_Identifier": classids
        }))
      })
    })

    if (this.selectedTransMethod.Provider_Method.toLowerCase().includes('mobile money')) {
      const body = {
        "Payment_Service_Provider_Identifier": this.selectedTransMethod.Payment_Service_Provider_Identifier,
        "School_Payment_Service_Provider_Identifier": null,
        "Currency_Short_Symbol": this.schoolAgreementForFeature.Invoice_Currency,
        "Branch_Identifier": null,
        "Payer_Payee": this.selectedTransMethod.Payer_Payee,
        "Payment_Amount": this.currentPackage.Total_Calculated_Price_After_Discount.toString(),
        "Payment_Mode": this.selectedTransMethod.Payment_Service_Provider_Name,
        "Mobile_Money_Phone_Number": this.selectedTransMethod.momophone,
        "Student_Bill_General_Ledger_Identifier": null,
        "Student_Identifier": null,
        "Classroom_Student_Identifier": null,
        "Currency_Identifier": this.schoolAgreementForFeature.Invoice_Currency_Identifier,
        "Created_By": this.sharedDataService.user_id,
        "External_Transaction_Type": "Prepaid Service",
        "External_Transaction_Body": [prepaidExternal],
        "Client_Application_Name": "Sims Web",
        "School_Identifier": this.school_id,
        "Transaction_Fee": this.transaction_fee,
        "Datetime": new Date().toJSON().substring(0, 10),
        "VoucherCode": this.selectedTransMethod.voucher
      };
      this.callmomoPay(body)

    } else if (this.selectedTransMethod.Provider_Method.toLowerCase().includes('card')) {
      this.createCardSession(prepaidExternal)
    } else if (this.selectedTransMethod.Provider_Method.toLowerCase().includes('bank')) {
      this.createBankRecord(prepaidExternal)
    }

  }

  CentralTransactionPointRenewal() {
    if (this.selectedTransMethod.Payment_Service_Provider_Name.toLowerCase().includes('card')) {
      if (!this.selectedTransMethod.Payer_Payee_Email) {
        return this.sharedDataService.celebrate("Please enter an email");
      }
    }

    if (this.selectedTransMethod.Payment_Service_Provider_Name.toLowerCase().includes('telecel') || this.selectedTransMethod.Payment_Service_Provider_Name.toLowerCase().includes('voda') || this.selectedTransMethod.Payment_Service_Provider_Name.toLowerCase().includes('mtn') || this.selectedTransMethod.Payment_Service_Provider_Name.toLowerCase().includes('at money') || this.selectedTransMethod.Payment_Service_Provider_Name.toLowerCase().includes('airtel') || this.selectedTransMethod.Payment_Service_Provider_Name.toLowerCase().includes('tigo')) {
      if (!this.selectedTransMethod.momophone) {
        return this.sharedDataService.celebrate("Please enter an a mobile money number")
      }
    }

    if (!this.currentPackage.Total_Calculated_Price_After_Discount) {
      return this.sharedDataService.celebrate('No amount has been set to be paid')
    }

    const transactionVal = this.currentPackage.Total_Calculated_Price_After_Discount * this.selectedTransMethod.Maximum_Transaction_Fee_Percentage
    if (transactionVal) {
      if (this.selectedTransMethod.Minimum_Transaction_Fee_Amount) {
        if (transactionVal < this.selectedTransMethod.Minimum_Transaction_Fee_Amount) {
          this.transaction_fee = this.selectedTransMethod.Minimum_Transaction_Fee_Amount
        } else {
          this.transaction_fee = transactionVal
        }
      }
      if (this.selectedTransMethod.Maximum_Transaction_Fee_Amount) {
        if (transactionVal > this.selectedTransMethod.Maximum_Transaction_Fee_Amount) {
          this.transaction_fee = this.selectedTransMethod.Minimum_Transaction_Fee_Amount
        } else {
          this.transaction_fee = transactionVal
        }
      }
      if (this.selectedTransMethod.Maximum_Transaction_Fee_Amount && this.selectedTransMethod.Minimum_Transaction_Fee_Amount) {
        if (transactionVal > this.selectedTransMethod.Minimum_Transaction_Fee_Amount && transactionVal < this.selectedTransMethod.Maximum_Transaction_Fee_Amount) {
          this.transaction_fee = transactionVal
        }
      }
    } else {
      this.transaction_fee = 0
    }
    this.failureInit = false
    this.allowUserVerify = false
    const prepaidExternal = {
      "Service_Price": parseFloat(this.currentPackage.Total_Calculated_Price_After_Discount),
      "Service_Type": this.serviceType,
      "Option_Duration": parseInt(this.currentPackage.Option_Duration),
      "Service_Package_Identifier": parseInt(this.selectedPackageUpgradeRenew.Service_Package_Identifier),
      "School_Identifier": parseInt(this.sharedDataService.school_id),
      "Service_Price_Exchange_Currency": this.currentPackage.Currency,
      "Service_Price_Exchange_Currency_USD_Rate": this.currentPackage.Service_Price_Exchange_Currency_USD_Rate,
      "GHS_USD_Exchange_Rate": this.currentPackage.GHS_USD_Exchange_Rate,
      "Service_Price_Withholding_Tax": this.currentPackage.WithHoldingTax,
      "Service_Price_Tax": this.currentPackage.Total_Taxes,
      "Taxes": this.currentPackage.Taxes,
      "Service_Package_Expiration_Date": this.currentPackage.Service_Expiration_Date,
      "Agreement_Identifier": this.schoolAgreementForFeature.Agreement_Identifier,
      "Total_Discount_Amount": this.currentPackage.Discount_Value,
      "Subscription_Duration": this.currentPackage.Option_Duration,
      "Total_Subscription_Students": this.SchoolStudentsList.length,
      "Gross_Price": this.currentPackage.CalCulated_Raw_Price,
      // "External_Payment_Identifier":417,
      "Created_By": parseInt(this.sharedDataService.user_id)
    }

    if (this.selectedTransMethod.Provider_Method.toLowerCase().includes('mobile money')) {
      const body = {
        "Payment_Service_Provider_Identifier": this.selectedTransMethod.Payment_Service_Provider_Identifier,
        "School_Payment_Service_Provider_Identifier": null,
        "Currency_Short_Symbol": this.schoolAgreementForFeature.Invoice_Currency,
        "Branch_Identifier": null,
        "Payer_Payee": this.selectedTransMethod.Payer_Payee,
        "Payment_Amount": this.currentPackage.Total_Calculated_Price_After_Discount.toString(),
        "Payment_Mode": this.selectedTransMethod.Payment_Service_Provider_Name,
        "Mobile_Money_Phone_Number": this.selectedTransMethod.momophone,
        "Student_Bill_General_Ledger_Identifier": null,
        "Student_Identifier": null,
        "Classroom_Student_Identifier": null,
        "Currency_Identifier": this.schoolAgreementForFeature.Invoice_Currency_Identifier,
        "Created_By": this.sharedDataService.user_id,
        "External_Transaction_Type": "Prepaid Service",
        "External_Transaction_Body": [prepaidExternal],
        "Client_Application_Name": "Sims Web",
        "School_Identifier": this.school_id,
        "Transaction_Fee": this.transaction_fee,
        // "Transaction_Fee": 0.00,
        "Datetime": new Date().toJSON().substring(0, 10),
        "VoucherCode": this.selectedTransMethod.voucher
      };
      this.callmomoPay(body)
    } else if (this.selectedTransMethod.Provider_Method.toLowerCase().includes('card')) {
      this.createCardSession(prepaidExternal)
    } else if (this.selectedTransMethod.Provider_Method.toLowerCase().includes('bank')) {
      this.createBankRecord(prepaidExternal,true)
    }
  }

  createBankRecord(body,isRenewal?) {
    if (!this.selectedTransMethod.Internal_Debit_API_URL) {
      return this.sharedDataService.celebrate("Invalid Url")
    }
    this.transactionInProgressMomo = true
    // const url = this.selectedTransMethod.Internal_Debit_API_URL.split(this.data.url_base_path)[1]
    this.sharedDataService.postHttp(this.selectedTransMethod.Internal_Debit_API_URL, body).toPromise().then(
      async (res) => {
        this.transactionInProgressMomo = false
        let result = res.json()
        // Prepaid_Service_Transaction
        let resids = []
        if(isRenewal){
          if (result.data) {
            resids = [result.data.Prepaid_Service_Transaction_Identifier]
          }
        }else{
          if (result.Prepaid_Service_Transaction.length) {
            resids = result.Prepaid_Service_Transaction.map((item: any) => item.Prepaid_Service_Transaction_Identifier)
          }
        }
        if (!resids.length) {
          this.sharedDataService.celebrate("Could not create Bank Reference")
          return
        }
        
        
       

        this.paymentVerification = true
        this.bankingDetails = true
        const schoolInfo = this.sharedDataService.schoolCache ? [...JSON.parse(this.sharedDataService.schoolCache)].find(item => item.School_Identifier == this.sharedDataService.school_id) : {}
        // this.verifyTransaction_External_Transaction_id = result.External_Payment_Id 
        this.externalMessage = `<h1 style="text-align:center;margin:0"> <span style="font-size:1.3rem !important;margin:5px 0;">Please make payment at any of these banks.</span> <br>
                                  <label style="font-size:1.3rem !important;margin:9px 0;">Provide this reference number when making payment </label><br>
                                  <label style="color:var(--schcol);font-size:1.3rem !important;font-weight:600 !important">${schoolInfo ? schoolInfo.School_Code : ''}-${schoolInfo ? schoolInfo.School_Identifier : ''}-${resids.join(" | ")} </label> </h1>`

        const url = "/micro_pricing/prepaid_service_transaction?" + this.sharedDataService.getActivityForUrl()
        const body = {
          "Prepaid_Service_Transactions": [],
          "Updated_By": this.sharedDataService.user_id
        }

        resids.forEach(item => {
          body.Prepaid_Service_Transactions.push({ "Prepaid_Service_Transaction_Identifier": item, "Transaction_Description": `${schoolInfo ? schoolInfo.School_Code : ''}-${schoolInfo ? schoolInfo.School_Identifier : ''}-${resids.join(" | ")}` })
        })

        this.sharedDataService.putHttp(url, body).subscribe()

        
      }, err => {
        this.transactionInProgressMomo = false
        this.paymentVerification = false
        this.bankingDetails = false

        this.failureInit = true
        this.paymentFailMessage = "We couldnt process your payment. click here to try again"

      }
    )
  }

  // Momo Transaction Payment
  externalMessage
  transactionInProgressMomo
  paymentVerification
  bankingDetails
  displayBankingDetails
  cardSessionLayout
  allowUserVerify
  failureInit
  callmomoPay(body) {
    if (!this.selectedTransMethod.Internal_Debit_API_URL) {
      return this.sharedDataService.celebrate("Invalid Url")
    }
    this.bankingDetails = false
    this.transactionInProgressMomo = true
    // const url = this.selectedTransMethod.Internal_Debit_API_URL.split(this.data.url_base_path)[1]
    this.sharedDataService.FreePostUrl(this.selectedTransMethod.Internal_Debit_API_URL, body).toPromise().then(
      res => {
        this.transactionInProgressMomo = false
        let result = res.json()
        if (result.External_Payment_Id) {
          this.paymentVerification = true
          this.verifyTransaction_External_Transaction_id = result.External_Payment_Id
          this.externalMessage = result.message
          this.performAutomatedStatusCheck()
        }
      }, err => {
        this.transactionInProgressMomo = false
        this.paymentVerification = false
        this.failureInit = true
        this.paymentFailMessage = "We couldnt process your payment. click here to try again"

      }
    )
  }


  // Card Payment
  refreshCardPage() {
    this.showCardArea = false;
    setTimeout(() => {
      this.showCardArea = true;
    }, 1000);
  }


  sessionID = null;
  showCardArea = false;
  showOTPArea = false;
  OTP = null;
  OTPhtml;
  OTPurl;
  OTPvalue;
  cardExPaymentID;
  cardTransID;
  billsForPayment;
  cardPaymentSuccessful
  authenticatedTransID
  async createCardSession(externalBody) {
    this.OTP = undefined;
    this.showOTPArea = false;
    this.cardPaymentSuccessful = false;

    const body = {
      "Payment_Service_Provider_Identifier": this.selectedTransMethod.Payment_Service_Provider_Identifier,
      "School_Payment_Service_Provider_Identifier": null,
      "Currency_Short_Symbol": this.schoolAgreementForFeature.Invoice_Currency,
      "Branch_Identifier": null,
      "Payer_Payee": this.selectedTransMethod.Payer_Payee_Email,
      "Payment_Amount": this.currentPackage.Total_Calculated_Price_After_Discount,
      "Payment_Mode": this.selectedTransMethod.Payment_Service_Provider_Name,
      "Mobile_Money_Phone_Number": this.selectedTransMethod.momophone,
      "Student_Bill_General_Ledger_Identifier": null,
      "Student_Identifier": null,
      "Classroom_Student_Identifier": null,
      "Currency_Identifier": this.schoolAgreementForFeature.Invoice_Currency_Identifier,
      "Created_By": this.sharedDataService.user_id,
      "External_Transaction_Type": "Prepaid Service",
      "External_Transaction_Body": [externalBody],
      "Client_Application_Name": "Sims Web",
      "School_Identifier": this.school_id,
      "Transaction_Fee": this.transaction_fee,
      "Datetime": new Date().toJSON().substring(0, 10),
      "VoucherCode": this.selectedTransMethod.voucher
    };

    sessionStorage.setItem('tempPaymentBody', JSON.stringify(body));
    this.transactionInProgressMomo = true
    let sessionResponse = await this.sharedDataService.postHttp('/paid_services_gt_mastercard/session', body).toPromise().then(
      res => {
        this.transactionInProgressMomo = false
        this.sessionID = res.json().Response.session.id;
        this.cardExPaymentID = res.json().External_Payment_Identifier;
        this.cardSessionLayout = true
        this.showCardArea = true;
        
      }, err => {
        this.transactionInProgressMomo = false
        this.failureInit = true
        this.paymentFailMessage = "We couldnt process your payment. click here to try again"
      }
    );

  }


  otpResponse() {
    // this.endCardPayment();
    this.sharedDataService.celebrate('Call final payment API');
  }

  successfullCardEntryResponse;
  paymentFailMessage
  loadingAuth: boolean = false;
  async cardPaymentResponse(event) {
    
    if (event.errors) {
      this.sharedDataService.celebrate(event.issue);
      if (!event.issue.includes('Invalid')) {
        this.endCardPayment();
      }
    }
    else if (event.session.updateStatus == 'SUCCESS') {
      this.successfullCardEntryResponse = event;
      this.loadingAuth = true;
      this.endCardPayment();
      
      this.sharedDataService.celebrate('Payment Initiated Successfully');
      // this.sharedDataService.showSpinner();

      let authenticateTransactionBody =
      {
        "Payment_Service_Provider_Identifier": 53,
        "Currency_Short_Symbol": this.schoolAgreementForFeature.Invoice_Currency,
        "Session_ID": this.sessionID,
        "External_Payment_Identifier": this.cardExPaymentID,
        "Created_By": this.sharedDataService.user_id,
        "Payer_Payee": this.selectedTransMethod.Payer_Payee_Email
      };


      let authenticateTransactionResponse = await this.sharedDataService.postHttp('/paid_services_gt_mastercard/auth', authenticateTransactionBody).toPromise().then(
        res => {
          this.sharedDataService.celebrate('Please Wait To Enter OTP');
          let authRez = res.json().Authenticate_User_Response.authentication;
          this.OTPhtml = authRez.redirect.html.replaceAll("\\", "");
          this.authenticatedTransID = res.json().Transaction_ID;
          // this.OTPurl= authRez.redirect.customizedHtml['3ds2'].acsUrl;
          // this.OTPvalue= authRez.redirect.customizedHtml['3ds2'].cReq;

          

          this.OTP = {
            html: this.OTPhtml,
            url: this.OTPurl,
            value: this.OTPvalue
          }

          
          this.showOTPArea = true;
          this.loadingAuth = true;
        }
      );
    }
    else {
      
    }
  }

  triggerRedirect() {
    window.open(`http://localhost:4201/#/checkout-card-payment?session_id=${this.sessionID}&order_id=${this.cardExPaymentID}&transaction_id=${this.authenticatedTransID}&currency=${this.schoolAgreementForFeature.Invoice_Currency}&email=${this.selectedTransMethod.Payer_Payee_Email}`, "_blank")
  }

  endCardPayment() {
    this.showCardArea = false;
    // this.sessionID = null;

    var scriptToRemove = document.getElementById("card-entry-1");
    var scriptToRemove2 = document.getElementById("card-entry-2");
    if (scriptToRemove) { scriptToRemove.parentNode.removeChild(scriptToRemove) }
    if (scriptToRemove2) { scriptToRemove2.parentNode.removeChild(scriptToRemove2) }

    this.showOTPArea = false;
    this.OTP = null;
    // this.usingCard = false;
  }

  serviceProviders: any[] = [];
  serviceProvidersCopy: any[];
  currencyAllowedForMomo = ["GHS"]
  getMomo() {

    const url = '/payment_service_provider?prepaid_services=1&status=Active';
    this.sharedDataService.getHttp(url).subscribe(
      res => {
        const providers = res.json();
        this.serviceProviders = Array.isArray(providers) ? providers : [];
        this.serviceProviders.push(this.bankOject)
        this.serviceProviders.forEach(element => {
          // if (element.Provider_Method == 'Mobile Money') {
          //   element.Payment_Service_Provider_Name += ' (ONLINE)'          
          // }
          if (element.Payment_Service_Provider_Name.toLowerCase().includes('mtn')) {
            element.image = this.mtnString
            element.isInCountry = this.currencyAllowedForMomo.includes(this.schoolAgreementForFeature.Invoice_Currency)
          }
          if (element.Payment_Service_Provider_Name.toLowerCase().includes('at money') || element.Payment_Service_Provider_Name.toLowerCase().includes('atmoney') || element.Payment_Service_Provider_Name.toLowerCase().includes('airtel') || element.Payment_Service_Provider_Name.toLowerCase().includes('tigo')) {
            element.image = this.airtelString
            element.isInCountry = this.currencyAllowedForMomo.includes(this.schoolAgreementForFeature.Invoice_Currency)
          }
          if (element.Payment_Service_Provider_Name.toLowerCase().includes('telecel') || element.Payment_Service_Provider_Name.toLowerCase().includes('vodafone')) {
            element.image = this.telecelString
            element.isInCountry = this.currencyAllowedForMomo.includes(this.schoolAgreementForFeature.Invoice_Currency)
          }
          if (element.Payment_Service_Provider_Name.toLowerCase().includes('card')) {
            element.image = this.visaString
            element.isInCountry = true
          }
          if (element.Payment_Service_Provider_Name.toLowerCase().includes('bank')) {
            element.image = this.bankString
            element.isInCountry = true
          }
        });
      },
      err => {
        const error = err.json();
      }
    );

  }

  singleFeatureFound: any = { Help_Video_Url: '' }
  hasClassFilter: number = null
  FetchClientVideo(feature) {
    const clientID = this.resolveClientResourceID(feature)
    if (!clientID) {
      return this.sharedDataService.celebrate("No ID Found")
    }

    const url = '/platform/clientapplicationresources?client_resource_id=' + clientID;
    this.sharedDataService.getHttp(url).subscribe(
      res => {
        const singleFeature = res.json();
        this.singleFeatureFound = Array.isArray(singleFeature) ? singleFeature[0] : typeof res.json() == 'object' ? res.json() : null;
        if (this.singleFeatureFound) {
          this.cartbody.forEach(item => {
            if (item.Client_Application_Resource_Identifier == this.singleFeatureFound.Client_Application_Resource_Identifier)
              item.Client_Application_Resource_Display_Name = this.singleFeatureFound.Client_Application_Resource_Display_Name
          })
          if (this.singleFeatureFound.Has_Classroom_Filter == 0) {
            this.selectedClassroom = this.SchoolClassroom.map(clss => clss.Classroom_Identifier)
            this.hasClassFilter = this.singleFeatureFound.Has_Classroom_Filter
          } else {
            this.hasClassFilter = this.singleFeatureFound.Has_Classroom_Filter
          }
        }
      },
      err => {
        const error = err.json();
      }
    );

  }

  countStatus = 0
  async performAutomatedStatusCheck(count = 6) {

    this.countStatus++
    let globalStep
    // const url = `/transaction_status_check?ext_pymt_id=3112`
    this.allowUserVerify = false
    const url = `/transaction_status_check?ext_pymt_id=${this.verifyTransaction_External_Transaction_id}`
    const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

    for (let i = 0; i < count; i++) {
      if (!this.transactionInProgressMomo && !this.paymentVerification && !this.showCardArea && !this.failureInit) {
        return
      }
      try {
        // await delay(20000 * (i + 1));
        await delay(45000);
        this.externalMessage = "Please wait while we verify your payment";

        const res = await this.sharedDataService.getHttp(url).toPromise();
        const verificationStatus = res.json();
        globalStep = verificationStatus
        
        if (verificationStatus) {
          if (verificationStatus.Transaction_Status) {
            if (verificationStatus.Transaction_Status.toLowerCase() == "completed") {
              this.handleLoging('Payment has been verified successfully', true)
              this.sharedDataService.showAlert("Payment Successfull", "Payment has been verified successfully",
                async () => {
                  await this.sharedDataService.getSchoolPrepaidServices();
                  await this.getSchoolPrepaids();
                  await this.sharedDataService.getSchoolAgreement();
                  await this.fetchTransactionHistorySchool();
                  await this.mergeActiveAgreementsAndPrepaids();
                  if (this.data) {
                    if (this.data.refreshAllowed) {
                      this.sharedDataService.celebrate("Refreshing Data Please wait")
                      setTimeout(() => {
                        window.location.reload();
                      }, 600);
                    } else {
                      this.sharedDataService.celebrate("Please wait")
                      // setTimeout(()=>{
                      this.data.intialiseClassrooms()
                      this.data.callbackFunc()
                      // this.sharedDataService.closeSpinner()
                      // },400)
                    }

                  }
                  this.SchoolCurrentPackage = this.schoolPackagesList.find(item => item.Service_Package_Identifier == this.schoolAgreementForFeature.Service_Package_Identifier)
                  if (this.SchoolCurrentPackage) {
                    if (this.schoolAgreementForFeature.Service_Package_Expiration_Date) {
                      this.SchoolCurrentPackage['isExpired'] = moment(this.schoolAgreementForFeature.Service_Package_Expiration_Date).isBefore(moment(), 'day')
                    }
                  }
                  this.SchoolCurrentPackageBackup = cloneDeep(this.SchoolCurrentPackage)
                  this.SchoolCurrentPackageBackup1 = cloneDeep(this.SchoolCurrentPackage)
                },
                () => { },
                'Okay',
                '', false, 'prepaid alert')
              this.callLogingSteps()
              if (this.data) {
                this.prePaidRef.close()
              }
              if (window.location.href.includes("school-subscriptions")) {
                this.schoolPackagesList = []
                this.getSchoolPackages(true);
                this.fromProfile = false
              } else if (window.location.href.includes("my-subscriptions")) {
                this.mySubscriptionPageIndex = 0
              }
              break;
            } else if (verificationStatus.Transaction_Status.toLowerCase() == "failed") {
              this.handleLoging('payment was unsuccessful', true)
              this.callLogingSteps()
              this.sharedDataService.showAlert("Payment Failed", "Your payment was unsuccessful ", async () => { await this.sharedDataService.getSchoolPrepaidServices(); await this.getSchoolPrepaids(); await this.sharedDataService.getSchoolAgreement(); await this.mergeActiveAgreementsAndPrepaids() }, () => { }, 'Okay', '')
              break;
            }
          } else {
            if (verificationStatus.message.toLowerCase().includes("completed")) {
              this.handleLoging('Payment has been verified successfully', true)

              this.sharedDataService.showAlert("Payment Successfull", "Payment has been verified successfully", async () => {
                await this.sharedDataService.getSchoolPrepaidServices(); await this.getSchoolPrepaids(); await this.sharedDataService.getSchoolAgreement(); await this.fetchTransactionHistorySchool(); await this.mergeActiveAgreementsAndPrepaids();
                if (this.data) {
                  if (this.data.refreshAllowed) {
                    this.sharedDataService.celebrate("Refreshing Data Please wait")
                    setTimeout(() => {
                      window.location.reload();
                    }, 600);
                  } else {
                    this.sharedDataService.celebrate("Please wait")
                    // setTimeout(()=>{
                    this.data.callbackFunc()
                    this.data.intialiseClassrooms()
                    // this.sharedDataService.closeSpinner()
                    // },400)
                  }

                }
                this.SchoolCurrentPackage = this.schoolPackagesList.find(item => item.Service_Package_Identifier == this.schoolAgreementForFeature.Service_Package_Identifier)
                if (this.SchoolCurrentPackage) {
                  if (this.schoolAgreementForFeature.Service_Package_Expiration_Date) {
                    this.SchoolCurrentPackage['isExpired'] = moment(this.schoolAgreementForFeature.Service_Package_Expiration_Date).isBefore(moment(), 'day')
                  }
                }
                this.SchoolCurrentPackageBackup = cloneDeep(this.SchoolCurrentPackage)
                this.SchoolCurrentPackageBackup1 = cloneDeep(this.SchoolCurrentPackage)
              }, () => { }, 'Okay', '', false, 'prepaid alert')
              this.callLogingSteps()
              if (this.data) {
                this.prePaidRef.close()
              }
              if (window.location.href.includes("school-subscriptions")) {
                this.schoolPackagesList = []
                this.getSchoolPackages(true);
                this.fromProfile = false
              } else if (window.location.href.includes("my-subscriptions")) {
                this.mySubscriptionPageIndex = 0
              }
              break;
            } else if (verificationStatus.message.toLowerCase().includes("failed") || verificationStatus.message.toLowerCase().includes("error")) {
              this.handleLoging('payment was unsuccessful', true)
              this.sharedDataService.showAlert("Payment Failed", "Your payment was unsuccessful ", async () => { await this.sharedDataService.getSchoolPrepaidServices(); await this.getSchoolPrepaids(); await this.sharedDataService.getSchoolAgreement(); await this.mergeActiveAgreementsAndPrepaids() }, () => { }, 'Okay', '')
              this.callLogingSteps()
              break;
            }
          }
        }
      } catch (err) {
        this.handleLoging('payment was unsuccessful', true)
        this.callLogingSteps()
        // this.sharedDataService.celebrate("Sorry w')
        console.error('Error fetching data:', err);
      }
    }
    if (this.countStatus < 2) {
      this.allowUserVerify = true
    } else {
      if (globalStep.Transaction_Status.toLowerCase() == 'pending') {
        this.transactionInProgressMomo = false
        this.failureInit = true
        this.paymentVerification = false
        this.paymentFailMessage = `Payment couldnt be verified contact customer success team via your school's whatsapp support page using this reference ${this.verifyTransaction_External_Transaction_id}`
      }
    }
  }

  async reloadStatusCheck(paymentid) {
    let globalStep
    if (!paymentid) {
      this.sharedDataService.celebrate('No payment referrence found')
      return
    }
    this.sharedDataService.showSpinner()
    // const url = `/transaction_status_check?ext_pymt_id=3112`
    const url = `/transaction_status_check?ext_pymt_id=${paymentid}`

    try {
      const res = await this.sharedDataService.getHttp(url).toPromise();
      const verificationStatus = res.json();
      this.sharedDataService.closeSpinner()
      globalStep = verificationStatus
      if (verificationStatus) {
        if (verificationStatus.Transaction_Status) {
          if (verificationStatus.Transaction_Status.toLowerCase() == "completed") {
            this.sharedDataService.showAlert("Payment Successfull", "Payment has been verified successfully", async () => {
              await this.sharedDataService.getSchoolPrepaidServices(); await this.getSchoolPrepaids(); await this.sharedDataService.getSchoolAgreement(); await this.fetchTransactionHistorySchool(); await this.mergeActiveAgreementsAndPrepaids();
              this.SchoolCurrentPackage = this.schoolPackagesList.find(item => item.Service_Package_Identifier == this.schoolAgreementForFeature.Service_Package_Identifier)
              if (this.SchoolCurrentPackage) {
                if (this.schoolAgreementForFeature.Service_Package_Expiration_Date) {
                  this.SchoolCurrentPackage['isExpired'] = moment(this.schoolAgreementForFeature.Service_Package_Expiration_Date).isBefore(moment(), 'day')
                }
              }
              this.SchoolCurrentPackageBackup = cloneDeep(this.SchoolCurrentPackage)
              this.SchoolCurrentPackageBackup1 = cloneDeep(this.SchoolCurrentPackage)
            }, () => { }, 'Okay', '')
            if (this.data) {
              this.prePaidRef.close()
            }
          } else if (verificationStatus.Transaction_Status.toLowerCase() == "failed") {
            this.sharedDataService.showAlert("Payment Failed", "Your payment was unsuccessful ", async () => { await this.sharedDataService.getSchoolPrepaidServices(); await this.getSchoolPrepaids(); await this.sharedDataService.getSchoolAgreement(); await this.fetchTransactionHistorySchool(); await this.mergeActiveAgreementsAndPrepaids() }, () => { }, 'Okay', '')
          }
        } else {
          if (verificationStatus.message.toLowerCase().includes("completed")) {
            this.sharedDataService.showAlert("Payment Successfull", "Payment has been verified successfully", async () => {
              await this.sharedDataService.getSchoolPrepaidServices(); await this.getSchoolPrepaids(); await this.sharedDataService.getSchoolAgreement(); await this.fetchTransactionHistorySchool(); await this.mergeActiveAgreementsAndPrepaids();
              this.SchoolCurrentPackage = this.schoolPackagesList.find(item => item.Service_Package_Identifier == this.schoolAgreementForFeature.Service_Package_Identifier)
              if (this.SchoolCurrentPackage) {
                if (this.schoolAgreementForFeature.Service_Package_Expiration_Date) {
                  this.SchoolCurrentPackage['isExpired'] = moment(this.schoolAgreementForFeature.Service_Package_Expiration_Date).isBefore(moment(), 'day')
                }
              }
              this.SchoolCurrentPackageBackup = cloneDeep(this.SchoolCurrentPackage)
              this.SchoolCurrentPackageBackup1 = cloneDeep(this.SchoolCurrentPackage)
            }, () => { }, 'Okay', '')
            if (this.data) {
              this.prePaidRef.close()
            }
          } else if (verificationStatus.message.toLowerCase().includes("failed") || verificationStatus.message.toLowerCase().includes("error")) {
            this.sharedDataService.showAlert("Payment Failed", "Your payment was unsuccessful ", async () => { await this.sharedDataService.getSchoolPrepaidServices(); await this.getSchoolPrepaids(); await this.sharedDataService.getSchoolAgreement(); await this.fetchTransactionHistorySchool(); await this.mergeActiveAgreementsAndPrepaids() }, () => { }, 'Okay', '')
          }
        }
      }
    } catch (err) {
      this.sharedDataService.closeSpinner()
      // this.sharedDataService.celebrate("Sorry w')
      console.error('Error fetching data:', err);
    }
  }

  bodyForLoging = []
  handleLoging(action = 'Hits Paywall', paymentInitiated = false) {
    let body = {
      "User_Name": this.sharedDataService.user_full_name,
      "User_Identifier": this.sharedDataService.user_id,
      "User_Action": `User ${action}`,
      "Client_Application_Resource_Identifiers": this.cartbody.map(clientId => this.resolveClientResourceID(clientId.Client_Application_Resource_Name)),
      "Created_DateTime": new Date,
      "Step_Order": this.bodyForLoging.length,
      "Payment_Initiated": paymentInitiated
    }
    if (paymentInitiated) {
      body['Payment_Details'] = {
        "Payment_Mode": this.selectedTransMethod.Payment_Service_Provider_Name,
        "Payment_Mode_Identifier": this.selectedTransMethod.Payment_Service_Provider_Identifier,
        "Payment_Amount": this.currentPackage.Total_Calculated_Price_After_Discount,
        "Transaction_Fee": this.transaction_fee,
      }
    }
    if (this.bodyForLoging.find(item => item.User_Action == body.User_Action)) {
      const existingBody = this.bodyForLoging.find(item => item.User_Action == body.User_Action)
      if (existingBody.Classroom_Action_Type_List_Ids.length != this.selectedClassroom.length) {
        body['Classroom_Action_Type'] = `User changed Selected Classrooms to (${this.selectedClassroom.length})`
        body['Classroom_Action_Type_List_Ids'] = this.selectedClassroom
      }
      if (existingBody.User_Action_Type_School_Employees_Ids.length != this.schoolEmployeesList.filter(item => item.isUserSelected).length) {
        body['User_Action_Type'] = `User changed Selected Employees to (${this.schoolEmployeesList.filter(item => item.isUserSelected).length})`
        body['User_Action_Type_School_Employees_Ids'] = this.schoolEmployeesList.filter(item => item.isUserSelected)
      }
      if (existingBody.Package_Details.Package_Name != this.currentPackage.Option_Name) {
        body['User_Action'] = body['User_Action'] + ' and changes package option details'
        body['Package_Details'] = { Package_Id: this.currentPackage.Prepaid_Service_Pricing_Option_Identifier, Package_Name: this.currentPackage.Option_Name, Package_Price: this.currentPackage.Total_Calculated_Price_After_Discount, Discount_Value: this.currentPackage.Discount_Value }
      }
    } else {
      body['Classroom_Action_Type'] = `Selected Classrooms (${this.selectedClassroom.length})`
      body['Classroom_Action_Type_List_Ids'] = this.selectedClassroom
      body['User_Action_Type'] = `Selected Employees/Users (${this.schoolEmployeesList.filter(item => item.isUserSelected).length})`
      body['User_Action_Type_School_Employees_Ids'] = this.schoolEmployeesList.filter(item => item.isUserSelected).map(_ => _.School_Employee_Identifier)
      body['Package_Details'] = { Package_Id: this.currentPackage.Prepaid_Service_Pricing_Option_Identifier, Package_Name: this.currentPackage.Option_Name, Package_Price: this.currentPackage.Total_Calculated_Price_After_Discount, Discount_Value: this.currentPackage.Discount_Value }
    }
    this.bodyForLoging.push(body)
    
  }

  callLogingSteps() {
    const url = '/prepaid_logs?' + this.sharedDataService.getActivityForUrl();
    this.sharedDataService.postHttp(url, this.bodyForLoging).subscribe(
      res => {
      },
      err => {
      }
    );
  }

  async mergeActiveAgreementsAndPrepaids() {
    let schoolInfo = [];
    let currency = [];
    if (this.sharedDataService.schoolCache) {
      schoolInfo = [...JSON.parse(this.sharedDataService.schoolCache)]
    }
    if (this.sharedDataService.schoolCurrenciesCache) {
      currency = [...JSON.parse(this.sharedDataService.schoolCurrenciesCache)]
    }


    let allAgreements: any = this.sharedDataService.checkForCurrentAgreement()
    let allPrepaidSerives: any = this.sharedDataService.school_prepaid_services ? [...JSON.parse(this.sharedDataService.school_prepaid_services)] : []
    //Filter prepaid services that have completed Transaction Status
    allPrepaidSerives = allPrepaidSerives.filter(prepaid => prepaid.Transaction_Status.toLowerCase() == "completed" || prepaid.Transaction_Status.toLowerCase() == "pending")

    if (!allAgreements.length) {

      return this.schoolAgreementForFeature
    } else {
      // remember to filter out pending records 
      // Sort the agreement by expiration date and bring the record that oldest date first.
      allAgreements = allAgreements.sort((a, b) => moment(a.Service_Package_Expiration_Date).diff(moment(b.Service_Package_Expiration_Date)));
      allPrepaidSerives = allPrepaidSerives.sort((a, b) => moment(a.Service_Expiration_Date).diff(moment(b.Service_Expiration_Date)));

      // Use agreement with the oldest expiration date
      this.pieChartTransaction = []
      this.getAllPrepaids()
      let latestAgreement = allAgreements[0]
      this.myExhaustiveSubscription[0] = []
      // this.myExhaustiveSubscription[0] = [...allPrepaidSerives]
      this.prepaidsBackup = [...allPrepaidSerives]
      // this.pieChartTransaction = [allPrepaidSerives.filter(item => item.Transaction_Status == 'Completed').length, allPrepaidSerives.filter(item => item.Transaction_Status == 'Pending').length, allPrepaidSerives.filter(item => item.Transaction_Status == 'Failed').length]
      this.myExhaustiveSubscription[1] = this.groupFeaturesIntoModule(latestAgreement.Service_Package_Client_Application_Resources)
      allPrepaidSerives = allPrepaidSerives.filter(user => user.Transaction_Status != 'Pending')

      if (!this.invoiceCurrency) {
        await this.getInvoiceCurrency(latestAgreement);
        if (!this.invoiceCurrency) {
          return;
        }
      }

      if (moment(latestAgreement.Service_Package_Expiration_Date).isBefore(moment(), 'day')) {
        this.schoolAgreementForFeature = { ...latestAgreement, 'packaged_Status': 'expired' }
        if (!this.schoolAgreementForFeature['country']) {
          this.schoolAgreementForFeature['country'] = schoolInfo[0].Country
          this.schoolAgreementForFeature['Invoice_Currency_Identifier'] = this.invoiceCurrency;
        }
        this.schoolAgreementForFeature['ActivePurchasedFeatures'] = [...allPrepaidSerives]

      } else {
        this.schoolAgreementForFeature = { ...latestAgreement, 'packaged_Status': 'active' }
        if (!this.schoolAgreementForFeature['country']) {
          this.schoolAgreementForFeature['country'] = schoolInfo[0].Country
          this.schoolAgreementForFeature['Invoice_Currency_Identifier'] = this.invoiceCurrency;
        }
        this.schoolAgreementForFeature['ActivePurchasedFeatures'] = [...allPrepaidSerives, ...latestAgreement.Service_Package_Client_Application_Resources]
      }
    }
  }

  invoiceCurrency = null;
  async getInvoiceCurrency(agreement:any){     
    let schoolCurrencies = this.sharedDataService.schoolCurrenciesCache ? JSON.parse(this.sharedDataService.schoolCurrenciesCache) : [];
    let invoiceCurrencyFound = schoolCurrencies.find(currency => currency.Currency_Short_Symbol == agreement.Invoice_Currency);
    if(!invoiceCurrencyFound){
      let allCurrenciesFetch = await this.sharedDataService.httpGetAsync('/transaction/currencies?all_curr=1' + this.sharedDataService.getActivityForUrl('Fetch Invoice Currency'));
      if (allCurrenciesFetch.status == 200) {
        let allCurrencies = Array.isArray(allCurrenciesFetch.json()) ? [...allCurrenciesFetch.json()] : [];
        let invoiceCurrencyFound2 = allCurrencies.find(currency => currency.Currency_Short_Symbol == agreement.Invoice_Currency);
        console.log(invoiceCurrencyFound2);
        if (invoiceCurrencyFound2) {
          this.invoiceCurrency = invoiceCurrencyFound2.Currency_Identifier;
        }
        else{
          this.sharedDataService.celebrate('Invoice Currency Not Found');
        }
      }
    }
    else{
      this.invoiceCurrency = invoiceCurrencyFound.Currency_Identifier;
    }
  }

  prepaidsBackup
  getAllPrepaids(showspinner?) {
    this.pieChartTransaction = [0, 0, 0]
    this.totalSumPrice = 0
    this.totalSumPricepend = 0
    this.totalSumPricefaild = 0
    this.prepaidsBackup = []
    if (showspinner) {
      this.sharedDataService.showSpinner()
    }
    if (this.SelfTransactionDialog != null) {
      this.SelfTransactionDialog.close()
    }
    let prepaidServices = `/micro_pricing/prepaid_service_transaction?school_id=${this.school_id}&pay_user_id=${this.sharedDataService.user_id}&school_employee_id=${this.sharedDataService.school_emp_Id}&start_date=${this.sharedDataService.getDateFormatted(this.startDateModel)}&end_date=${this.sharedDataService.getDateFormatted(this.endDateModel)}`
    this.sharedDataService.getHttp(prepaidServices).toPromise().then(
      res => {
        if (showspinner) {
          this.sharedDataService.closeSpinner()
        }
        let result = Array.isArray(res.json()) ? [...res.json()] : []
        if (!result.length) {
          this.pieChartTransaction = [0, 0, 0]
          // this.celebrate('No User Found');
          this.myExhaustiveSubscription[0] = []
          return
        }
        result = _.orderBy(result, ['Purchase_Datetime'], ['desc']);
        if (this.mytransactionModalData) {
          this.mytransactionModalData = result.find(item => item.Prepaid_Service_Transaction_Identifier == this.mytransactionModalData.Prepaid_Service_Transaction_Identifier)
        } else {
          //  this.SelfTransactionDialog?this.SelfTransactionDialog.close():''
        }
        result.forEach(trans => {
          trans['isExpired'] = moment(trans.Service_Expiration_Date).isBefore(moment(), 'day') || moment(trans.Service_Expiration_Date).isSame(moment(), 'day')
          trans.Prepaid_Service_Transaction_Classrooms.forEach((clss, index) => {
            const searchClass = this.SchoolClassroom.find(item => item.Classroom_Identifier == clss.Classroom_Identifier)
            if (searchClass) {
              trans.Prepaid_Service_Transaction_Classrooms[index] = {
                ...cloneDeep(clss),
                ...searchClass
              };
            }
          });

          trans.Prepaid_Service_Transaction_Users.forEach((user, index) => {
            if (user.School_Employee_Identifier) {

              const searchEmployee = this.schoolEmployeesList.find(item => item.School_Employee_Identifier == user.School_Employee_Identifier)
              if (searchEmployee) {
                trans.Prepaid_Service_Transaction_Users[index] = {
                  ...cloneDeep(user),
                  ...searchEmployee
                };
              }
            }
            if (user.Legal_Guardian_Identifier) {
              const searchLegalGuardian = this.schoolLegalGuardianList.find(item => item.Legal_Guardian_Identifier == user.Legal_Guardian_Identifier)
              if (searchLegalGuardian) {
                trans.Prepaid_Service_Transaction_Users[index] = {
                  ...cloneDeep(user),
                  ...searchLegalGuardian
                };
              }
            }
          });
        })
        
        // this.checkedForAppUser = true;
        this.myExhaustiveSubscription[0] = [...result]
        this.prepaidsBackup = [...result]
        this.totalSumPrice = _.sumBy(result.filter(item => item.Transaction_Status == 'Completed'), 'Service_Price')
        this.totalSumPricepend = _.sumBy(result.filter(item => item.Transaction_Status == 'Pending'), 'Service_Price')
        this.totalSumPricefaild = _.sumBy(result.filter(item => item.Transaction_Status == 'Failed'), 'Service_Price')
        this.pieChartTransaction = [result.filter(item => item.Transaction_Status == 'Completed').length, result.filter(item => item.Transaction_Status == 'Pending').length, result.filter(item => item.Transaction_Status == 'Failed').length]
      }, err => {
        if (showspinner) {
          this.sharedDataService.closeSpinner()
        }
        this.sharedDataService.celebrate(this.sharedDataService.handleErrorMessage(err))
      }
    )
  }

  SchoolCurrentPackage
  SchoolCurrentPackageBackup
  SchoolCurrentPackageBackup1
  getSchoolPackages(id?) {
    if (this.schoolPackagesList.length) {
      this.tabName = 'review'
      this.serviceType="Renewal"
      return this.mySubscriptionPageIndex = 1
    }
    this.sharedDataService.showSpinner()
    this.tabName = 'review'
    let url = `/infoviewPay/service_package`
    this.sharedDataService.getHttp(url).subscribe(
      res => {
        this.sharedDataService.closeSpinner()
        let result = Array.isArray(res.json()) ? res.json() : []
        this.schoolPackagesList = result.filter(item => ((item.Visible_On_Prepaid_Service == 1 || this.schoolAgreementForFeature.Service_Package_Identifier == item.Service_Package_Identifier) && this.schoolAgreementForFeature.Service_Base_Package_Type == item.Service_Base_Package_Type))
        if (!this.schoolPackagesList.length) {
          return this.sharedDataService.celebrate("No School service packages found for your school")
        } else {
          if(this.directRedirect){
            const nowPack = this.schoolPackagesList.find(item => item.Service_Package_Identifier == this.schoolAgreementForFeature.Service_Package_Identifier)
            if(nowPack){
              this.showCheckoutService(nowPack)
            }else{
              this.showupgradePrompt()
            }
          }else{
            this.mySubscriptionPageIndex = 1
          }
          this.schoolPackagesList.forEach(schools => {
            schools.currency = this.schoolAgreementForFeature.Invoice_Currency ? this.schoolAgreementForFeature.Invoice_Currency.toLowerCase() == 'ghs' ? "GHS" : "USD" : "GHS"
            schools.amountToShow = this.schoolAgreementForFeature.Invoice_Currency ? this.schoolAgreementForFeature.Invoice_Currency.toLowerCase() == 'ghs' ? schools.Service_Package_Price : schools.Service_Package_Price_USD : schools.Service_Package_Price
            schools['GroupedBody'] = schools['Service_Package_Client_Application_Resources'].reduce((prev, curr) => {
              if (prev.find(item => item.Client_Application_Resource_Module == curr.Client_Application_Resource_Module && curr.Client_Application_Resource_Module != "Module")) {
                prev.find(item => {
                  if (item.Client_Application_Resource_Module == curr.Client_Application_Resource_Module && curr.Client_Application_Resource_Module != "Module") {
                    item.GroupedFeatures.push(curr)
                    item.GroupedFeatures = sortBy(item.GroupedFeatures, 'Client_Application_Resource_Name')

                  }
                })
              } else {
                if (curr.Client_Application_Resource_Module != "Module" && curr.Client_Application_Resource_Module && curr.Client_Application_Resource_Module != " ") {
                  prev.push(
                    {
                      Client_Application_Resource_Module: curr.Client_Application_Resource_Module,
                      Has_Classroom_Filter: curr.Has_Classroom_Filter,
                      GroupedFeatures: [curr],
                    }
                  )
                }
              }

              return prev
            }, [])

            schools.Desc = schools['GroupedBody'].length + " Modules " + _.sum(schools['GroupedBody'].map(item => item.GroupedFeatures.length)) + " Features"
          })
          if (id) {
            requestAnimationFrame(() => {
              this.SchoolCurrentPackage = this.schoolPackagesList.find(item => item.Service_Package_Identifier == this.schoolAgreementForFeature.Service_Package_Identifier)
              if (this.SchoolCurrentPackage) {
                if (this.schoolAgreementForFeature.Service_Package_Expiration_Date) {
                  this.SchoolCurrentPackage['isExpired'] = moment(this.schoolAgreementForFeature.Service_Package_Expiration_Date).isBefore(moment(), 'day')
                }
              }
              this.SchoolCurrentPackageBackup = cloneDeep(this.SchoolCurrentPackage)
              this.SchoolCurrentPackageBackup1 = cloneDeep(this.SchoolCurrentPackage)
            })
          }
        }
      }, err => {
        this.sharedDataService.closeSpinner()
        this.sharedDataService.celebrate(this.sharedDataService.handleErrorMessage(err))
      }
    )
  }


  sortDataColHeader(sort: Sort) {
    const data = this.myExhaustiveSubscription[0].slice();
    if (!sort.active || sort.direction === "") {
      this.myExhaustiveSubscription[0] = data;
      return;
    }

    this.myExhaustiveSubscription[0] = data.sort((a, b) => {
      const isAsc = sort.direction === "asc";

      switch (sort.active) {
        case "id":
          return this.sharedDataService.compare(
            a.Prepaid_Service_Transaction_Identifier,
            b.Prepaid_Service_Transaction_Identifier,
            isAsc
          );
        case "feature":
          return this.sharedDataService.compare(
            a.Client_Application_Resource_Name,
            b.Client_Application_Resource_Name,
            isAsc
          );
        case "classrooms":
          return this.sharedDataService.compare(
            a.Prepaid_Service_Transaction_Classrooms.length,
            b.Prepaid_Service_Transaction_Classrooms.length,
            isAsc
          );
        case "users":
          return this.sharedDataService.compare(
            a.Prepaid_Service_Transaction_Users.length,
            b.Prepaid_Service_Transaction_Users.length,
            isAsc
          );
        case "status":
          return this.sharedDataService.compare(
            a.Transaction_Status,
            b.Transaction_Status,
            isAsc
          );
        case "price":
          return this.sharedDataService.compare(
            a.Service_Price,
            b.Service_Price,
            isAsc
          );
        case "date":
          return this.sharedDataService.compare(
            a.Created_Datetime,
            b.Created_Datetime,
            isAsc
          );
        case "expiry":
          return this.sharedDataService.compare(
            a.Service_Expiration_Date,
            b.Service_Expiration_Date,
            isAsc
          );
        default:
          return 0;
      }
    });
  }

  sortDataColHeader2(sort: Sort) {
    const data = this.schoolTransactionsHistory.slice();
    if (!sort.active || sort.direction === "") {
      this.schoolTransactionsHistory = data;
      return;
    }

    this.schoolTransactionsHistory = data.sort((a, b) => {
      const isAsc = sort.direction === "asc";

      switch (sort.active) {
        case "id":
          return this.sharedDataService.compare(
            a.Prepaid_Service_Transaction_Identifier,
            b.Prepaid_Service_Transaction_Identifier,
            isAsc
          );
        case "feature":
          return this.sharedDataService.compare(
            a.Client_Application_Resource_Name,
            b.Client_Application_Resource_Name,
            isAsc
          );
        case "classrooms":
          return this.sharedDataService.compare(
            a.Prepaid_Service_Transaction_Classrooms.length,
            b.Prepaid_Service_Transaction_Classrooms.length,
            isAsc
          );
        case "users":
          return this.sharedDataService.compare(
            a.Prepaid_Service_Transaction_Users.length,
            b.Prepaid_Service_Transaction_Users.length,
            isAsc
          );
        case "status":
          return this.sharedDataService.compare(
            a.Transaction_Status,
            b.Transaction_Status,
            isAsc
          );
        case "price":
          return this.sharedDataService.compare(
            a.Service_Price,
            b.Service_Price,
            isAsc
          );
        case "date":
          return this.sharedDataService.compare(
            a.Created_Datetime,
            b.Created_Datetime,
            isAsc
          );
        case "expiry":
          return this.sharedDataService.compare(
            a.Service_Expiration_Date,
            b.Service_Expiration_Date,
            isAsc
          );
        default:
          return 0;
      }
    });
  }

  groupFeaturesIntoModule(list) {
    list.reduce((prev, curr) => {
      if (prev.find(item => item.Client_Application_Resource_Module == curr.Client_Application_Resource_Module && curr.Client_Application_Resource_Module != "Module")) {
        prev.find(item => {
          if (item.Client_Application_Resource_Module == curr.Client_Application_Resource_Module && curr.Client_Application_Resource_Module != "Module") {
            item.GroupedFeatures.push(curr)
            item.GroupedFeatures = sortBy(item.GroupedFeatures, 'Client_Application_Resource_Name')

          }
        })
      } else {
        if (curr.Client_Application_Resource_Module != "Module" && curr.Client_Application_Resource_Module && curr.Client_Application_Resource_Module != " ") {
          prev.push(
            {
              Client_Application_Resource_Module: curr.Client_Application_Resource_Module,
              Has_Classroom_Filter: curr.Has_Classroom_Filter,
              GroupedFeatures: [curr],
            }
          )
        }
      }

      return prev
    }, [])

    return list
  }

  filterPrepaidsTogglebnts(value) {
    if (value) {
      this.myExhaustiveSubscription[0] = this.prepaidsBackup.filter(item => item.Transaction_Status == value)
    } else {
      this.myExhaustiveSubscription[0] = cloneDeep(this.prepaidsBackup)
    }
  }
  filterPrepaidsTogglebnts2(value, tabtype) {
    this.LineChartTransactionLabels2 = []
    this.LineChartTransaction2[0].data = []
    if (!tabtype) {
      if (value == 0) {
        this.schoolTransactionsHistory = cloneDeep(this.schoolTransactionsHistoryBackup)
      }
      if (value == 1) {
        this.schoolTransactionsHistory = this.schoolTransactionsHistoryBackup.filter(item => item.Transaction_Status == "Completed")
      }
      if (value == 2) {
        this.schoolTransactionsHistory = this.schoolTransactionsHistoryBackup.filter(item => item.Transaction_Status == "Pending")
      }
      if (value == 3) {
        this.schoolTransactionsHistory = this.schoolTransactionsHistoryBackup.filter(item => item.Transaction_Status == "Failed")
      }
    } else if (tabtype == "Feature") {
      if (value == 0) {
        this.schoolTransactionsHistory = cloneDeep(this.schoolTransactionsHistoryBackup.filter(upper => upper.Service_Type == "Feature"))
      }
      if (value == 1) {
        this.schoolTransactionsHistory = this.schoolTransactionsHistoryBackup.filter(upper => upper.Service_Type == "Feature").filter(item => item.Transaction_Status == "Completed")
      }
      if (value == 2) {
        this.schoolTransactionsHistory = this.schoolTransactionsHistoryBackup.filter(upper => upper.Service_Type == "Feature").filter(item => item.Transaction_Status == "Pending")
      }
      if (value == 3) {
        this.schoolTransactionsHistory = this.schoolTransactionsHistoryBackup.filter(upper => upper.Service_Type == "Feature").filter(item => item.Transaction_Status == "Failed")
      }
    } else {
      if (value == 0) {
        this.schoolTransactionsHistory = cloneDeep(this.schoolTransactionsHistoryBackup.filter(upper => upper.Service_Type == "Renewal" || upper.Service_Type == "Upgrade"))
      }
      if (value == 1) {
        this.schoolTransactionsHistory = this.schoolTransactionsHistoryBackup.filter(upper => upper.Service_Type == "Renewal" || upper.Service_Type == "Upgrade").filter(item => item.Transaction_Status == "Completed")
      }
      if (value == 2) {
        this.schoolTransactionsHistory = this.schoolTransactionsHistoryBackup.filter(upper => upper.Service_Type == "Renewal" || upper.Service_Type == "Upgrade").filter(item => item.Transaction_Status == "Pending")
      }
      if (value == 3) {
        this.schoolTransactionsHistory = this.schoolTransactionsHistoryBackup.filter(upper => upper.Service_Type == "Renewal" || upper.Service_Type == "Upgrade").filter(item => item.Transaction_Status == "Failed")
      }
    }

    requestAnimationFrame(() => {
      this.LineChartTransactionLabels2 = ["Completed", "Pending", "Failed"]
      let chartGraph = []
      this.LineChartTransactionLabels2.forEach(label => {
        chartGraph.push(this.schoolTransactionsHistory.filter(serv => serv.Transaction_Status == label).length)
      })

      this.totalSumPrice2 = _.sumBy(this.schoolTransactionsHistory.filter(item => item.Transaction_Status == 'Completed'), 'Service_Price')
      this.totalSumPricepend2 = _.sumBy(this.schoolTransactionsHistory.filter(item => item.Transaction_Status == 'Pending'), 'Service_Price')
      this.totalSumPricefaild2 = _.sumBy(this.schoolTransactionsHistory.filter(item => item.Transaction_Status == 'Failed'), 'Service_Price')
      this.LineChartTransaction2[0].data = chartGraph
    })

  }

  showupgradePrompt() {
    this.sharedDataService.showAlert('Upgrade Package', "You are about to modify your school subscription. This might change the features you currently use. Would you like to continue?", () => { this.getSchoolPackages(); this.tabName = 'upgrade' }, () => { }, "Yes", "No")
  }

  setDates(term) {
    this.startDateModel = term.Begin_Date
    this.endDateModel = term.End_Date
  }
  setDates2(term) {
    this.startDateModel2 = term.Begin_Date
    this.endDateModel2 = term.End_Date
  }

  findTransFeature(event) {
    let text = event.target.value.toLowerCase();
    this.toggleProducts = 0
    if (text) {
      this.myExhaustiveSubscription[0] = this.prepaidsBackup.filter(prepaid => prepaid.Client_Application_Resource_Display_Name ? prepaid.Client_Application_Resource_Display_Name.toLowerCase().includes(text) : false || prepaid.Package_Name.toLowerCase().includes(text) || prepaid.Prepaid_Service_Transaction_Identifier.toString().includes(text))
      // this.myExhaustiveSubscription[0] = this.prepaidsBackup.filter(prepaid => prepaid.Client_Application_Resource_Display_Name.toLowerCase().includes(text) || prepaid.Prepaid_Service_Transaction_Identifier.toString().includes(text))
    } else {
      this.myExhaustiveSubscription[0] = this.prepaidsBackup
    }
  }

  findsubHistory(event) {
    let text = event.target.value.toLowerCase();
    this.SchoolCurrentPackageBackup.GroupedBody = this.SchoolCurrentPackageBackup1.GroupedBody
      .map(item => {
        const matchesModule = item.Client_Application_Resource_Module ? item.Client_Application_Resource_Module.toLowerCase().includes(text.toLowerCase()) : false;
        const matchingFeatures = item.GroupedFeatures.filter(feature =>
          feature.Client_Application_Resource_Name.toLowerCase().includes(text.toLowerCase())
        );

        // Only return the item if there are matching features or if the module matches
        if (matchesModule) {
          return {
            ...item,
            GroupedFeatures: item.GroupedFeatures
          };
        }
        if (matchingFeatures.length > 0) {
          return {
            ...item,
            GroupedFeatures: matchingFeatures
          };
        }
        return null;
      }).filter(item => item != null)

    if (!text) {
      this.SchoolCurrentPackageBackup = cloneDeep(this.SchoolCurrentPackageBackup1)
    }
  }

  findTransFeature2(event) {
    let text = event.target.value.toLowerCase();
    this.toggleFeatureType = ""
    this.toggleProducts2 = 0
    if (text) {
      this.schoolTransactionsHistory = this.schoolTransactionsHistoryBackup.filter(prepaid => prepaid.Client_Application_Resource_Display_Name ? prepaid.Client_Application_Resource_Display_Name.toLowerCase().includes(text) : false || prepaid.Package_Name.toLowerCase().includes(text) || prepaid.Prepaid_Service_Transaction_Identifier.toString().includes(text))
    } else {
      this.schoolTransactionsHistory = this.schoolTransactionsHistoryBackup
    }
  }

  getSchoolPrepaids(showspinner?) {
    this.pieChartTransaction = [0, 0, 0]
    this.totalSumPrice = 0
    this.totalSumPricepend = 0
    this.totalSumPricefaild = 0
    this.prepaidsBackup = []
    this.toggleProducts = 0
    this.mytransactionSearch = ''
    if (this.SelfTransactionDialog != null) {
      this.SelfTransactionDialog.close()
    }
    if (showspinner) {
      this.sharedDataService.showSpinner()
    }
    let prepaidServices = `/micro_pricing/prepaid_service_transaction?school_id=${this.school_id}&pay_user_id=${this.sharedDataService.user_id}&school_employee_id=${this.sharedDataService.school_emp_Id}&start_date=${this.sharedDataService.getDateFormatted(this.startDateModel)}&end_date=${this.sharedDataService.getDateFormatted(this.endDateModel)}`
    this.sharedDataService.getHttp(prepaidServices).toPromise().then(
      res => {
        if (showspinner) {
          this.sharedDataService.closeSpinner()
        }
        let result = Array.isArray(res.json()) ? [...res.json()] : []
        if (!result.length) {
          this.pieChartTransaction = [0, 0, 0]
          // this.celebrate('No User Found');
          this.myExhaustiveSubscription[0] = []
          return
        }
        result = _.orderBy(result, ['Purchase_Datetime'], ['desc']);
        result.forEach(trans => {
          trans['isExpired'] = moment(trans.Service_Expiration_Date).isBefore(moment(), 'day') || moment(trans.Service_Expiration_Date).isSame(moment(), 'day')
          trans.Prepaid_Service_Transaction_Classrooms.forEach((clss, index) => {
            const searchClass = this.SchoolClassroom.find(item => item.Classroom_Identifier == clss.Classroom_Identifier)
            if (searchClass) {
              trans.Prepaid_Service_Transaction_Classrooms[index] = {
                ...cloneDeep(clss),
                ...cloneDeep(searchClass)
              };
            }
          });
          if (!trans.Prepaid_Service_Transaction_Classrooms.length) {
            // trans.Prepaid_Service_Transaction_Classrooms = this.SchoolClassroom
          }

          if (trans.Prepaid_Service_Transaction_Users.length) {
            trans.Prepaid_Service_Transaction_Users.forEach((user, index) => {
              if (user.School_Employee_Identifier) {

                const searchEmployee = this.schoolEmployeesList.find(item => item.School_Employee_Identifier == user.School_Employee_Identifier)
                if (searchEmployee) {
                  trans.Prepaid_Service_Transaction_Users[index] = {
                    ...cloneDeep(user),
                    ...cloneDeep(searchEmployee)
                  };
                }
              }
              if (user.Legal_Guardian_Identifier) {
                const searchLegalGuardian = this.schoolLegalGuardianList.find(item => item.Legal_Guardian_Identifier == user.Legal_Guardian_Identifier)
                if (searchLegalGuardian) {
                  trans.Prepaid_Service_Transaction_Users[index] = {
                    ...cloneDeep(user),
                    ...cloneDeep(searchLegalGuardian)
                  };
                }
              }
            });
          } else {
            // trans.Prepaid_Service_Transaction_Users = this.schoolEmployeesList
          }
        })
        
        // this.checkedForAppUser = true;
        this.myExhaustiveSubscription[0] = [...result]
        this.prepaidsBackup = [...result]
        this.totalSumPrice = _.sumBy(result.filter(item => item.Transaction_Status == 'Completed'), 'Service_Price')
        this.totalSumPricepend = _.sumBy(result.filter(item => item.Transaction_Status == 'Pending'), 'Service_Price')
        this.totalSumPricefaild = _.sumBy(result.filter(item => item.Transaction_Status == 'Failed'), 'Service_Price')
        this.pieChartTransaction = [result.filter(item => item.Transaction_Status == 'Completed').length, result.filter(item => item.Transaction_Status == 'Pending').length, result.filter(item => item.Transaction_Status == 'Failed').length]
      }, err => {
        if (showspinner) {
          this.sharedDataService.closeSpinner()
        }
        this.sharedDataService.celebrate(this.sharedDataService.handleErrorMessage(err))
      }
    )
  }


  showSelfTransaction(value) {
    this.mytransactionModalData = cloneDeep(value)
    
    this.SelfTransactionDialog = this.dialog.open(this.SelfTransaction, {
      width: "65%",
      disableClose: false
    })
  }

  showservicesPackages(value) {
    this.showDets = 0
    this.servicePackageModalData = value
    
    this.servicesPackagesDialog = this.dialog.open(this.servicesPackages, {
      width: "78%",
      disableClose: false
    })
  }

  fetchTransactionHistorySchool() {
    if (!this.startDateModel2) {
      return this.sharedDataService.celebrate("Please select a start date")
    }
    if (!this.endDateModel2) {
      return this.sharedDataService.celebrate("Please select an end date")
    }

    this.sharedDataService.showSpinner()
    this.LineChartTransactionLabels2 = []
    // this.lineChartLabels = [];
    this.LineChartTransaction2[0].data = [];
    this.totalSumPrice2 = 0
    this.totalSumPricepend2 = 0
    this.totalSumPricefaild2 = 0
    this.toggleProducts2 = 0
    this.mytransactionSearch2 = ''
    let prepaidServices = `/micro_pricing/prepaid_service_transaction?school_id=${this.school_id}&start_date=${this.sharedDataService.getDateFormatted(this.startDateModel2)}&end_date=${this.sharedDataService.getDateFormatted(this.endDateModel2)}`
    this.sharedDataService.getHttp(prepaidServices).toPromise().then(
      res => {
        this.sharedDataService.closeSpinner()
        let result = Array.isArray(res.json()) ? [...res.json()] : []
        if (!result.length) {
          return
        }
        result = _.orderBy(result, ['Purchase_Datetime'], ['desc']);
        if (this.mytransactionModalData) {
          this.mytransactionModalData = result.find(item => item.Prepaid_Service_Transaction_Identifier == this.mytransactionModalData.Prepaid_Service_Transaction_Identifier)
        } else {
          // this.SelfTransactionDialog?this.SelfTransactionDialog.close():''
        }
        result.forEach(trans => {
          trans['isExpired'] = moment(trans.Service_Expiration_Date).isBefore(moment(), 'day') || moment(trans.Service_Expiration_Date).isSame(moment(), 'day')
          trans.Prepaid_Service_Transaction_Classrooms.forEach((clss, index) => {
            const searchClass = this.SchoolClassroom.find(item => item.Classroom_Identifier == clss.Classroom_Identifier)
            if (searchClass) {
              trans.Prepaid_Service_Transaction_Classrooms[index] = {
                ...cloneDeep(clss),
                ...cloneDeep(searchClass)
              };
            }
          });
          if (!trans.Prepaid_Service_Transaction_Classrooms.length) {
            // trans.Prepaid_Service_Transaction_Classrooms = this.SchoolClassroom
          }

          if (trans.Prepaid_Service_Transaction_Users.length) {
            trans.Prepaid_Service_Transaction_Users.forEach((user, index) => {
              if (user.School_Employee_Identifier) {

                const searchEmployee = this.schoolEmployeesList.find(item => item.School_Employee_Identifier == user.School_Employee_Identifier)
                if (searchEmployee) {
                  trans.Prepaid_Service_Transaction_Users[index] = {
                    ...cloneDeep(user),
                    ...cloneDeep(searchEmployee)
                  };
                }
              }
              if (user.Legal_Guardian_Identifier) {
                const searchLegalGuardian = this.schoolLegalGuardianList.find(item => item.Legal_Guardian_Identifier == user.Legal_Guardian_Identifier)
                if (searchLegalGuardian) {
                  trans.Prepaid_Service_Transaction_Users[index] = {
                    ...cloneDeep(user),
                    ...cloneDeep(searchLegalGuardian)
                  };
                }
              }
            });
          } else {
            // trans.Prepaid_Service_Transaction_Users = this.schoolEmployeesList
          }
        })
        
        // this.checkedForAppUser = true;
        this.schoolTransactionsHistory = [...result]
        this.schoolTransactionsHistoryBackup = [...result]
        this.LineChartTransactionLabels2 = ["Completed", "Pending", "Failed"]
        let chartGraph = []
        this.LineChartTransactionLabels2.forEach(label => {
          chartGraph.push(result.filter(serv => serv.Transaction_Status == label).length)
        })

        this.totalSumPrice2 = _.sumBy(result.filter(item => item.Transaction_Status == 'Completed'), 'Service_Price')
        this.totalSumPricepend2 = _.sumBy(result.filter(item => item.Transaction_Status == 'Pending'), 'Service_Price')
        this.totalSumPricefaild2 = _.sumBy(result.filter(item => item.Transaction_Status == 'Failed'), 'Service_Price')
        this.LineChartTransaction2[0].data = chartGraph
        setTimeout(() => {
          this.filterPrepaidsTogglebnts2(this.toggleProducts2, this.toggleFeatureType)
        }, 400);
      }, err => {
        this.sharedDataService.closeSpinner()
        this.sharedDataService.celebrate(this.sharedDataService.handleErrorMessage(err))
      })
  }

  groupByMonth(objects) {
    // Array of month names for easy conversion
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    return objects.reduce((grouped, item) => {
      const date = new Date(item.Purchase_Datetime);
      const monthYear = `${monthNames[date.getMonth()]}-${date.getFullYear()}`;

      if (!grouped[monthYear]) {
        grouped[monthYear] = [];
      }

      grouped[monthYear].push(item);

      return grouped;
    }, {});
  }

  formatExpirationDate(expirationDate) {
    // const now = moment().utc();
    const expiration = moment.utc(this.sharedDataService.getDateFormatted(expirationDate));
    const daysDifference = expiration.diff(this.sharedDataService.getDateFormatted(), 'days');

    if (daysDifference <= 3 && daysDifference > 0) {
      // Show the duration in text (e.g., "3 days", "2 days", "tomorrow", "today")
      return "In " + expiration.fromNow(true); // `true` omits the "in" or "ago" prefix
    } else if (daysDifference <= 0) {
      return "Expired"
    } else {
      // Show the date if it's more than 3 days away
      return expiration.format('MMM DD, YYYY');
    }
  }

  formatExpirationDate2(expirationDate = '2024-11-21') {
    const now = moment.utc(); // Current date in UTC
    const expiration = moment.utc(this.sharedDataService.getDateFormatted(expirationDate)); // Expiration date in UTC

    const daysDifference = expiration.diff(now, 'days');

    if (daysDifference > 0) {
      return `${daysDifference} days left`;
    } else if (daysDifference == 0) {
      return this.sharedDataService.getDateFormatted(expirationDate) == this.sharedDataService.getDateFormatted() ? "Expiring Today" : "Expiring Tomorrow";
    } {
      return 'Expired';
    }
  }

  renewFeature(clientUi) {
    this.isFeaturesList = false
    this.mySubscriptionPageIndex = 2
    this.cartbody = []
    this.cartbody.push(
      {
        Client_Application_Resource_Name: clientUi.Client_Application_Resource_Name,
        Client_Application_Resource_Display_Name: clientUi.Client_Application_Resource_Display_Name,
        purchased_by: this.sharedDataService.user_full_name,
        purchased_personId: this.sharedDataService.user_id,
        Help_Video_Url: "",
        isSel: false,
      }
    )
    this.selectedClassroom = clientUi.Prepaid_Service_Transaction_Classrooms.map(item => item.Classroom_Identifier)
    const emps = clientUi.Prepaid_Service_Transaction_Users.map(item => item.School_Employee_Identifier).filter(us => us)
    this.schoolEmployeesList.forEach(emp => {
      if (emps.includes(emp.School_Employee_Identifier)) {
        emp.isUserSelected = true
      }
    })
    this.pathMapping(3)
  }

  showCheckoutService(packid) {
    if (packid.Service_Package_Status == 'Active') {
      this.mySubscriptionPageIndex = 3
      this.isFeaturesList = false
      this.ProcessInitiation = false
      this.pageStepper = 3
      this.stepperIndex = this.pageStepper - 1
      this.calculatePacakage2(packid)
      this.handleLoging(`navigates to package duration and pricing option for Services`)
    } else {
      this.tabName = 'upgrade'
      this.sharedDataService.showAlert('', "the current package you are on has been discontinued, please choose a new package to continue.", () => { }, () => { }, "Okay")
      if (this.schoolPackagesList.length) {
        // return this.mySubscriptionPageIndex = 1
        return
      }
      let url = `/infoviewPay/service_package`
      this.sharedDataService.getHttp(url).subscribe(
        res => {
          this.sharedDataService.closeSpinner()
          let result = Array.isArray(res.json()) ? res.json() : []
          this.schoolPackagesList = result.filter(item => ((item.Visible_On_Prepaid_Service == 1 || this.schoolAgreementForFeature.Service_Package_Identifier == item.Service_Package_Identifier) && this.schoolAgreementForFeature.Service_Base_Package_Type == item.Service_Base_Package_Type) && item.Service_Package_Status == 'Active')
          if (!this.schoolPackagesList.length) {
            return this.sharedDataService.celebrate("No School service packages found for your school")
          } else {

            this.mySubscriptionPageIndex = 1
            this.schoolPackagesList.forEach(schools => {
              schools.currency = this.schoolAgreementForFeature.Invoice_Currency
              schools['GroupedBody'] = schools['Service_Package_Client_Application_Resources'].reduce((prev, curr) => {
                if (prev.find(item => item.Client_Application_Resource_Module == curr.Client_Application_Resource_Module && curr.Client_Application_Resource_Module != "Module")) {
                  prev.find(item => {
                    if (item.Client_Application_Resource_Module == curr.Client_Application_Resource_Module && curr.Client_Application_Resource_Module != "Module") {
                      item.GroupedFeatures.push(curr)
                      item.GroupedFeatures = sortBy(item.GroupedFeatures, 'Client_Application_Resource_Name')

                    }
                  })
                } else {
                  if (curr.Client_Application_Resource_Module != "Module" && curr.Client_Application_Resource_Module && curr.Client_Application_Resource_Module != " ") {
                    prev.push(
                      {
                        Client_Application_Resource_Module: curr.Client_Application_Resource_Module,
                        Has_Classroom_Filter: curr.Has_Classroom_Filter,
                        GroupedFeatures: [curr],
                      }
                    )
                  }
                }

                return prev
              }, [])

              schools.Desc = schools['GroupedBody'].length + " Modules " + _.sum(schools['GroupedBody'].map(item => item.GroupedFeatures.length)) + " Features"
            })
          }
        }, err => {
          this.sharedDataService.closeSpinner()
          this.sharedDataService.celebrate(this.sharedDataService.handleErrorMessage(err))
        }
      )
    }

  }

  getPermissions(rolesArray) {
    rolesArray.forEach(element => {
      if (element.Permission_Value == 1) {
        if (element.Client_Application_Resource_Name == "Subscription") {
          this.canViewSchoolPackages = true;
        }
      }
    });
  }

  async closePaywall() {
    //banking actions
    if(this.bankingDetails){
      await this.sharedDataService.getSchoolPrepaidServices();
        await this.getSchoolPrepaids();
        await this.sharedDataService.getSchoolAgreement();
        await this.fetchTransactionHistorySchool();
        await this.mergeActiveAgreementsAndPrepaids();
        if (this.data) {
          if (this.data.refreshAllowed) {
            this.sharedDataService.celebrate("Refreshing Data Please wait")
            setTimeout(() => {
              window.location.reload();
            }, 600);
          } else {
            this.sharedDataService.celebrate("Please wait")
            // setTimeout(()=>{
            this.data.intialiseClassrooms()
            this.data.callbackFunc()
            // this.sharedDataService.closeSpinner()
            // },400)
          }

        }
        this.SchoolCurrentPackage = this.schoolPackagesList.find(item => item.Service_Package_Identifier == this.schoolAgreementForFeature.Service_Package_Identifier)
        if (this.SchoolCurrentPackage) {
          if (this.schoolAgreementForFeature.Service_Package_Expiration_Date) {
            this.SchoolCurrentPackage['isExpired'] = moment(this.schoolAgreementForFeature.Service_Package_Expiration_Date).isBefore(moment(), 'day')
          }
        }
        this.SchoolCurrentPackageBackup = cloneDeep(this.SchoolCurrentPackage)
        this.SchoolCurrentPackageBackup1 = cloneDeep(this.SchoolCurrentPackage)
    }
    if (this.data) {
      this.callLogingSteps()
      this.prePaidRef.close()
      
      return this.pageStepper = 0
    } else {
      this.isFeaturesList = false
      this.mySubscriptionPageIndex = 0
      this.currentPackage = {
        "Option_Duration": "",
        "Option_Name": '',
        'Caculated_Raw_Price': '',
        "Price_After_Discount": "",
        "Tax": "",
      }
      this.callLogingSteps()
    }
  }

  printable(): void {
    const printContent = document.getElementById("printable");
    if (printContent) {
      requestAnimationFrame(()=>{ 
      const printWindow = window.open('', '', 'height=600,width=800');
      if (printWindow) {
        printWindow.document.write('<html><head><title>Print</title></head><body>');

        const stylesheets = Array.from(document.querySelectorAll('link[rel="stylesheet"], style'));
        stylesheets.forEach(style => {
          printWindow.document.write(style.outerHTML);
        });

        printWindow.document.write(printContent.innerHTML);
        printWindow.document.write('</body></html>');
        setTimeout(() => {
          printWindow.document.close();
          printWindow.print();
        }, 500);
      }
    })
    } else {
      console.error(`Element with id ${"printable"} not found`);
    }
  }

  canViewSchoolPackages: boolean
  mytransactionSearch
  mytransactionSearch2
  mytransactionModalData
  servicePackageModalData
  totalSumPrice = 0
  showDets = 0
  totalSumPricepend = 0
  totalSumPricefaild = 0
  totalSumPrice2 = 0
  totalSumPricepend2 = 0
  totalSumPricefaild2 = 0
  tabName = 'review'
  serviceType = "Feature"
  directRedirect:boolean
  pieChartTransaction = [0, 0, 0]
  LineChartTransaction2 = [{ data: [], label: 'Transaction History' }]
  pieChartTransactionLabels = ['Completed', 'Pending', 'Failed']
  LineChartTransactionLabels2 = []
  pieChartTransactionColors = [
    {
      backgroundColor: ["#78E08F", "#6fa6e6", "#F54B5E"],
    }
  ]
  LineChartTransactionColors2 = [
    {
      backgroundColor: ["#78E08F", "#6fa6e6", "#F54B5E"]
    }
  ]
  public barChartOptions: any = {
    responsive: true,
    scales: {
      xAxes: [{
        ticks: {
          autoSkip: false
        }
      }],
      yAxes: [{
        ticks: {
          beginAtZero: true,
          callback: function (value) { if (value % 1 === 0) { return value; } }
        }
      }]
    },
    title: {
      display: true,
      text: 'Transaction History'
    },
    legend: {
      display: false,
      position: 'right',
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 30,
          bottom: 0
        }

      },
      labels: {
        defaultFontFamily: 'Segoe UI',
        defaultFontSize: '0'
      }
    },
  };
  cartbody = []
  schoolPackagesList = []
  schoolTransactionsHistory = []
  schoolTransactionsHistoryBackup = []
  isLoadingFeatures: boolean
  isFailureFeuatures: any
  allSimsFeatures: any[] = []
  allSimsFeaturesBackup: any[] = []
  featureSearchVal: string
  toggleFeatureType = ""
  toggleProducts = 0
  toggleProducts2 = 0
  mySubscriptionPageIndex = 0
  selectedTransMethod: any = {
    "School_Payment_Service_Provider_Identifier": "",
    "Payment_Service_Provider_Name": "mtn"
  }
  mtnString = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAMAAACfWMssAAAAh1BMVEX/ywD/ywH/zwD/zQAAAAYAAAD/0wAAAAn/0QD2xgoAAAO6mg7ovwz/1QAAAA36ywrwww1xXgyoiwnftQjXsAx1Yw49Ng0ABwikiBBmVRFBOAmPdgyxkAteTw+3lxKIcRJ9ag8UEworJQ0eHA7RqhAiIRCegxTMqxdMQhbDoAtpWAwtKQtRRgrE099zAAACV0lEQVRIie1V7XabMAw1krAwHzXBJmGFBtIkdGny/s83OyVtSEi7/dl2TirOAQtzdWXryohAvF0iGF3TwzP39PB2Nvnh3pr5Iu43450w/oNUnZ3HPXNvzPxHa8TBfr8cQgBICTpPjUlz7ceAXzMiSLRVOV8wHY15PqssSMBPGTHSyQ9mih9ndVU0TVHVs0eimJ+WWqK4xSiivGVadEkKWeQMANw9g3TXrYi6XOI0I0Z1zKV1ABTnS3bpR9J2zC3CBGMA6fMxqhhv8mAgVUvrFK4ZwfCDPSbj9sG5iODN3V0ungmlXZGBy81F/bBSx7dquYkELjdmmSTJMl++ANhG+w9Bb1nhmFFEnYvmh6hizrM+LPvQmyG2WU/KV1JAyjN5wQg8y8QbkMKnnMMyN3X4YjWFWzkAAyE70uOqoAmXUTAA1/GWXeioCHMIaB53xQkIu9hicAmEE7Cah8XzTIIDoua+pZ/xAMRdvLkAIpfZOzCt5OodWGf7cGAMZHuZqohKSofNod7Jml8lVGHqgG1meGDEnK42BxWvh3IUFlw5doC2UBgUG4heCuU+DEDvOcdrAdDKet0MAoDAadC/R99nRwGYNdsrAbhkzZpaNS05h5e6pYWJpkQO2BK3Ro5FHryJ3Li+6TROtxXKtGPa1rtcSnnsKt9WUua7+pmoTG+1lV9HpJoDx7Q4dH3RJElT9N1hQTEdGiXHBRyvxEOl3vSve3dyxN6I96/9Rks4le+Tw8ovSYJKjbUmVS7SRWdPM360vWvIPzser9zpmZP/1/8dd/FH/ma8U8ZfAxAjCXQUrroAAAAASUVORK5CYII="
  vodafoneString = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAMAAACfWMssAAAAaVBMVEXmAAD////lAADnDg79+Pj3zMz53Nz65eXmFRToOTn2wsL51dX99fXpRUX0srL0tbXvg4PoNDTqUlLwlpbzrKz88PDvi4vpTEvypqXrYmLnHBzoQUD1vb3oLi776+rnKSntdHTxnp7saWh6FXICAAABpklEQVRIie2W2XaCMBCG4ZcIGBZFi9alVN//IQviJJGZpOpVe45z5Qn5nH0m0Sx6Ud7gvwBxk+dAoGwrpbWq262PFUDkVRIbSepcRBmIXBko3X3usUz1QUCnIHYGO5a9j6ev4eeGk1NwTpjqhssn0p2FweyDuO+rDqTG1S4EgrjiNHJLJ0iZHwTZWewnB1dr4QNxpjuUAMSuVPCAK7qxpBvZHRiXMgjK39z+My7KATVE0ChsXLdxcPzcSiA2XOH4obYlAQmkVLTTKsHCkBKY08dppnvS1HzDQZPrgpcl1gSuwUFyUQud0BFYCyA5ogQQBf9XA+oQSCmZB0DJVKk2mKlCcKxGyVQKTrwSQMqHFBzTemeusgmkwxYAtxXHQAHYkuMqafDIJWedjJt70s4BschtW/Ud65JOjYttZZMVDzOAUMy0OfU0suNKn+nLuHP2Z+fQMzqcYTVIoupqkbonG9+wup+GTPzj0U0Jl9BAdlcA44IrwG/tb0tnGiE5LiIYYaWm2EOLNbqu8sJSSV0KmPfxcBgfD1VbPvF4uLGvPFcekTf4l8AfVv8OxMH1yN8AAAAASUVORK5CYII="
  airtelString = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFwAAABcCAMAAADUMSJqAAAAsVBMVEUiPXboJiz////qPUI9PXHpMzgAPnkAImnZ3OUtO3MqPHMAKWzsJSkfO3Xk5uwZN3MALW7Gy9e4vcwSM3HuJCbyJCTz9PeFj6vAxNKlME/5+vycpLtZaJAAJWoAH2h+iacsRXticJauL0tROmzeJzFGO26osMNMXooAAFpAVIRue53O090AFGU2TH+PmbJ8NV/NKjvBLEJhOGiQNFicMlSIM1pxN2O7LkbTKTfGKj7rSE0QeXSLAAACsElEQVRoge3WaXOiMAAGYLCeG0Oi4VAOhaKyatXWeu7//2EbSUTwggrM7Mzm/aRRnoTc0rhaXqSWVGIELnCB/8v4L4H/7zgkgJSFI9fqTHA5OAn0SqXZKAWHrlkpC4d4XikNR3alPJxYDP/dCDNIGdgMOISIBp4+4m6ImwpP97meiiMHT73ZzHYdFOFROiAHDslg1tNZa+deo1AcupYepzC4wlNW01P8uqHzj2SBuYA5Wj7liMk1gw+oHqbnoqd2Sp8P6JrpDQPXDTqhqkz4VASOAxzwvN1pOPIsBAikkxEorNuLXESI8NaBXsjqBa9QRDAAIDGUWfGUQEw8q9uhUQrHoZOY6IXiyFXu0AXh5L5dCI4nfA11DWPYLBaHgFG66xAy6BWLI49R3ukmARL4IDdODNZwCC8422T0j6JwJbwCcZyP8JTvWGmby+PwbjHdWMt55zTpjkOwg+zXdcykpUN3rgZb/hbffPXJ0rI6ZspJ9Cznc2cIsWSzDjE6iQmfA2fXq1M7lfMmMAwSeO91XCJ2JRkDgGXie9b77r1gO3FAT+l5DIxLgZLHpjMGL1lnm8pkwY41LE14URe/PllYiLPwZl4AG5EEcWNhe7OA5OjwKKfbHIS3RSmP1Quo+qG9eiuN9j+12v1fLnmV/tLa8hUeeuP16nvTf6fpb7a7sfTTKiCl1bYsx3FK+Kv+UVY1VVXbPKqqaaP99lRD1kZLu4N2oiOcPrruH0caReXb0CpoBX6GN6jX/f5IOz9XC0vG35/qfTdeQfu4Wbce10B/8TcjNabUaN/3D5r6FI4qaGvtw34b1hCvJPzib/f0zRP/r0mHbHD8FeTR8eudjrU/rraqVX+33ewPsnrr1KQfyZd3oGOtnfOoR1/Es0XgAhe4wAUucIELXOACf4y/lZc/fwFyAkYfqnZnlgAAAABJRU5ErkJggg=="
  telecelString = "data:image/png;base64,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"
  visaString = "../../../assets/img/PrepaidServices/visaMaster.png"
  bankString = "../../../assets/img/PrepaidServices/cashBank.png"
  bankOject = {
    "Payment_Service_Provider_Identifier": null,
    "Payment_Service_Provider_Name": "Bank",
    "Payment_Service_Provider_Organisation": "Bank",
    "Internal_Debit_API_URL": "/micro_pricing/prepaid_service_transaction",
    "Internal_Credit_API_URL": null,
    "Provider_Method": "Bank",
    "Status": "Active",
    "Maximum_Transaction_Fee_Amount": null,
    "Minimum_Transaction_Fee_Amount": null,
    "Payment_Service_Provider_Type": "Bank Debit",
    "Prepaid_Service_Payment_Option_Indicator": 1,
    "Maximum_Transaction_Fee_Percentage": null,
    "Minimum_Transaction_Fee_Percentage": null
  }


  imageHistory = [
    "../../../assets/img/PrepaidServices/Credit card.gif",
    "../../../assets/img/PrepaidServices/Online world.gif",
    "../../../assets/img/PrepaidServices/Subscriptions-amico.png",
  ]

  BanksList = [
    {
      name: "GT Bank",
      accountname: "INFOVIEW DATA SOLUTIONS",
      account: 216111731110,
      branch: "EAST LEGON",
      bankcode: 300322,
      routingNumber: 230116,
      swift: "GTBIGHAC",
      image: "../../../assets/img/PrepaidServices/GTBank_logo.png",
      bankcolor: '#f90000'
    },
    {
      name: "Ecobank Bank",
      accountname: "INFOVIEW DATA SOLUTIONS",
      account: 1441000303428,
      branch: "RIDGE / HEAD OFFICE",
      bankcode: 300312,
      routingNumber: 130110,
      swift: "ECOCGHAC",
      image: "../../../assets/img/PrepaidServices/ecobank_logo.webp",
      bankcolor: '#00537b'
    },
    {
      name: "GCB Bank",
      accountname: "INFOVIEW DATA SOLUTIONS",
      account: 1641130000691,
      branch: "ADJIRINGANOR",
      bankcode: "300304",
      routingNumber: "040164",
      swift: "GHCBGHAC",
      image: "../../../assets/img/PrepaidServices/gcb-logo.png",
      bankcolor: '#ffbb13'
    },
  ]

  packagesList = []
  isFeaturesList: boolean = false
  maxVisibleFeatures: number = 4;
  visibleFeatures: string[] = [];
  remainingFeaturesCount: number = 0;

}



// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/modals/prepaid-services/prepaid-services.component.ts